/***************************************************************************
 * COPYRIGHT (C) 2013, Rapid7 LLC, Boston, MA, USA.
 * 모든 권한 보유. 본 자료에는 * Rapid7의 비공개 독점 정보를
 비롯해 비공개, 저작권 보호 저작물이 포함되었습니다.
 **************************************************************************/

const vulnerabilitiesByCvssScoreLabeling = {
  label: {
    cntHigh: '__percent__(__value__) 7.0 및 10',
    cntLow: '__percent__(__value__) 0 및 3.9',
    cntMedium: '__percent__(__value__) 4.0 및 6.9',
  },
  summary: {
    cntHigh: '__percent__의 취약점이 7.0에서 10 사이의 CVSS 지수가 있음',
    cntLow: '__percent__의 취약점이 0에서 3.9 사이의 CVSS 지수가 있음',
    cntMedium: '__percent__의 취약점이 4.0에서 6.9 사이의 CVSS 지수가 있음',
  },
  value: {
    cntHigh:
      '__percent__(__value__)의 취약점이 7.0에서 10 사이의<br/> CVSS 지수가 있음',
    cntLow:
      '__percent__(__value__)의 취약점이 0에서 3.9 사이의<br/> CVSS 지수가 있음',
    cntMedium:
      '__percent__(__value__)의 취약점이 4.0에서 6.9 사이의<br/> CVSS 지수가 있음',
  },
};

const vulnerabilitiesBySeverityLabeling = {
  label: {
    cntCritical: '__percent__(__value__) 취약점 상',
    cntModerate: '__percent__(__value__) 취약점 하',
    cntSevere: '__percent__(__value__) 취약점 중',
    cntSeverityUnknown: '__percent__(__value__) 취약점 알 수 없음',
  },
  summary: {
    cntCritical: '__percent__에 해당하는 귀하의 취약점이 심각도 상임',
    cntModerate: '__percent__에 해당하는 귀하의 취약점이 심각도 하임',
    cntSevere: '__percent__에 해당하는 귀하의 취약점이 심각도 중임',
    cntSeverityUnknown: '__percent__에 해당하는 귀하의 취약점을 알 수 없음',
  },
  value: {
    cntCritical:
      '__percent__(__value__)에 해당하는 귀하의 취약점이 심각도 상임',
    cntModerate:
      '__percent__(__value__)에 해당하는 귀하의 취약점이 심각도 하임',
    cntSevere: '__percent__(__value__)에 해당하는 귀하의 취약점이 심각도 중임',
    cntSeverityUnknown:
      '__percent__(__value__)에 해당하는 귀하의 취약점을 알 수 없음',
  },
};

const dayRangeLabels = {
  0: '0-29일',
  1: '30-59일',
  2: '60-90일',
  3: '90일 초과',
};
const severityLabels = {
  0: '$t(moderate)',
  1: '$t(severe)',
  2: '$t(critical)',
};
const cvssScoreLabels = {
  0: '0.1-3.9',
  1: '4.0-6.9',
  2: '7.0-10',
};

/* jshint maxlen: false */
export default {
  translation: {
    acronym: {
      vulnerabilities: '취약점',
    },
    active: '활성',
    activelyExploited: {
      entity: {
        cve: 'CVE',
        dateAdded: '날짜 추가됨',
        description: '설명',
        rationale: '사유',
        source: '소스',
        target: '대상',
      },
      title: 'Rapid7 위협 피드 세부 정보',
    },
    add: '추가',
    addCard: '카드 추가',
    addCardTitle: '카드 추가',
    addDashboard: '대시보드 추가',
    added: '추가',
    address: '주소',
    addresses: '주소',
    admin: {
      manageFilters: '$t(manage) $t(filters)',
      title: '$t(manage) 요소',
    },
    affects: '영향',
    agent: '에이전트',
    agentConnectionDetail: '에이전트 연결 세부 내용',
    agentDownloadTitle: 'Rapid7 에이전트 다운로드',
    agentDownloadTitle2: '에이전트 다운로드, 설치 및 배포',
    agentID: '에이전트 ID',
    agentInstructions:
      '<p>zip 파일을 시스템으로 복사합니다. 파일의 압축을 풉니다. 32비트 및 64비트 Windows 시스템용으로 MSI 설치 관리자 2개, config.json 및 3개의 보안 파일 client.key, client.crt, 및 cafile.pem이 제공됩니다.</p><p>관련 MSI 설치 관리자를 실행하여 에이전트를 설치하십시오. 기본적으로 에이전트는 c:\\Program Files (x86)\\Rapid7\\Endpoint Agent에 설치되며 보안 파일도 자동으로 설치됩니다. 에이전트는 서비스로 설치되며 "Rapid7 Endpoint Agent"로 확인할 수 있습니다.</p><p>에이전트 작업의 일환으로 정보는 “agent.log” 파일에 기록됩니다. 또한, 이 파일은 agent.log.1 및 agent.log.2에도 기록됩니다. 문제가 발생한 경우 문제 해결을 위해 당사는 이러한 로그 파일을 요청할 수 있습니다.</p>',
    agentManagement: '에이전트 관리',
    agentManagerTitle: '에이전트',
    agentStatus: '에이전트 상태',
    agentVersion: '버전',
    agents: '에이전트',
    agentsCount: '__count__에이전트',
    agentsOldVersion: '기존 버전 사용',
    agentsPage: {
      chartTitle: '운영 체제별 에이전트 포함 자산',
      summary:
        '__percent__에 해당하는 내 에이전트 포함 자산이 __os__ 운영 체제에서 실행됨',
    },
    agentsRecentlyAssessed: '최근 진단됨',
    alert: '알림',
    allCards: '모든 $t(cardsLabel)',
    and: '및',
    apply: '적용',
    approvedBy: '승인자',
    architecture: '아키텍처',
    areYouSure: '계속하시겠습니까?',
    assessed: '진단됨',
    asset_groups: '자산 그룹',
    asset_indefinite: '자산',
    asset_plural: '__count__ 자산',
    asset_plural_indefinite: '자산',
    assetCount: '자산 수',
    assetDetails: {
      contextDrivenRiskScore: '컨텍스트 기반 위험 지수',
      fetchFailed: '자산을 검색하지 못했습니다. 나중에 시도하십시오.',
      kpi: {
        malware: '멀웨어 키트',
        operatingSystemFingerprints: '핑거프린트',
      },
      rotatedTitle: '자산 개요 보기',
      save: '저장',
    },
    assetDetailsLabel: '자산 세부 정보',
    assetGroup: '자산 그룹',
    assetGroups: {
      donutTitle: '위험도가 가장 높은 그룹',
      labels: {
        assets: '자산',
      },
      title: '위험도가 가장 높은 주요 자산 그룹',
    },
    assetGroupsLabel: '자산 그룹',
    assetLabel: '자산',
    assetName: '자산 이름',
    assets: '자산',
    assetsAffected: '영향을 받은 자산 수',
    assetsByComponent: {
      OS: {
        title: '운영 체제별 자산',
      },
      assessmentStatus: {
        title: '진단 상태별 자산',
      },
    },
    assetsWithUnknownOS:
      '에 해당하는 내 $t(assets)이(가) 확인되지 않은 $t(operatingSystem)을(를) 실행함',
    assignTo: '할당 대상',
    assignees: '할당 대상',
    availableDashboard: '사용할 수 있는 대시보드',
    backToAll: '선택 취소',
    basicInfo: '기본 정보',
    cancel: '취소',
    cardActions: {
      close: '닫기',
      noChanges: '저장할 변경 사항이 카드에 없습니다',
      save: '카드 저장',
      saveAs: '새 카드로 저장',
      saveError:
        '카드 업데이트 도중 오류가 발생했습니다. 나중에 다시 시도하십시오.',
      savedExistingFilter: '필터가 업데이트되었습니다.',
      savedExistingFilterSelection: '카드가 업데이트되었습니다.',
      savedExistingFilterSelectionAndFilterContent:
        '필터가 저장되고 카드가 업데이트되었습니다.',
      savedExistingFilterToNewCard:
        '기존 필터가 저장되고 새 카드에 적용되었습니다.',
      savedNewCard: '새 카드가 생성되었습니다.',
      savedNewFilterToExistingCard:
        '새 필터가 저장되고 카드가 업데이트되었습니다.',
      savedNewFilterToNewCard: '새 필터가 카드에 저장되었습니다.',
      savedWithExistingFilter: '기존 필터 및 카드가 업데이트되었습니다.',
      unsavedChanges:
        '저장되지 않은 변경 사항이 카드에 있습니다. 계속하시겠습니까?',
    },
    cardEditModal: {
      errors: {
        titleInUse: '이 이름은 이미 사용 중입니다',
        titleRequired: '카드 이름을 비워 둘 수 없습니다.',
      },
      placeholder: {
        name: '카드 이름',
      },
      title: {
        saveAs: '다른 이름으로 저장',
      },
    },
    cardLibrary: {
      card: {
        'riskiest-sites': {
          description: '위험도가 가장 높은 사이트, 자산 및 해당 취약점',
          name: '위험도가 가장 높은 사이트',
        },
      },
      category: {
        agents: '$t(agents)',
        assets: '$t(assets)',
        exploitableVulns: '$t(exploitableVulns)',
        kpi: '$t(kpi)',
        remediations: '$t(remediations)',
        risk: '$t(risk)',
        sites: '$t(sites)',
        vulns: '$t(vulns)',
      },
    },
    cardSearch: '카드 검색',
    cardTemplates: {
      AgentsByOS: {
        description:
          '운영 체제별 연결 에이전트가 포함된 자산에 대한 분석이 나와 있는 카드입니다.',
        name: '운영 체제별 에이전트 포함 자산',
        summary:
          '__percent__에 해당하는 내 에이전트 포함 자산이 __os__ 운영 체제에서 실행됨',
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      AssetsByLastScanDate: {
        description: '스캔 시점을 기준으로 분류된 자산의 그래프를 표시합니다.',
        label: {
          later: '120일 초과',
          'period 1': '0-30일',
          'period 2': '30-60일',
          'period 3': '60-90일',
          'period 4': '90-120일',
        },
        name: '마지막 스캔 날짜별 자산',
        summary: {
          later: '__percent__에 해당하는 내 자산이 최근 120일 이전에 스캔됨',
          'period 1': '__percent__에 해당하는 내 자산이 최근 30일 내에 스캔됨',
          'period 2':
            '__percent__에 해당하는 내 자산이 최근 30-60일 내에 스캔됨',
          'period 3':
            '__percent__에 해당하는 내 자산이 최근 60-90일 내에 스캔됨',
          'period 4':
            '__percent__에 해당하는 내 자산이 최근 90-120일 내에 스캔됨',
        },
        value: {
          later:
            '__percent__(__value__)에 해당하는 내 자산이 최근 120일 이전에 스캔됨',
          'period 1':
            '__percent__(__value__)에 해당하는 내 자산이 최근 30일 내에 스캔됨',
          'period 2':
            '__percent__(__value__)에 해당하는 내 자산이 최근 30-60일 내에 스캔됨',
          'period 3':
            '__percent__(__value__)에 해당하는 내 자산이 최근 60-90일 내에 스캔됨',
          'period 4':
            '__percent__(__value__)에 해당하는 내 자산이 최근 90-120일 이전에 스캔됨',
        },
      },
      AssetsByOS: {
        description: '운영 체제별 자산에 대한 분석이 나와 있는 카드입니다.',
        name: '운영 체제별 자산',
        summary: '__percent__에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      AssetsByTotalScanTime: {
        description: '스캔 시간으로 분류한 자산의 그래프를 표시합니다.',
        label: {
          cntScanTime10To20: '10-20분',
          cntScanTime20To30: '20-30분',
          cntScanTime30To40: '30-40일 분',
          cntScanTimeGt40: '40분 초과',
          cntScanTimeLt10: '0-10분',
        },
        name: '총 스캔 시간별 자산',
        summary: {
          cntScanTime10To20:
            '__percent__에 해당하는 내 자산을 스캔하는 데 10-20분이 소요됨',
          cntScanTime20To30:
            '__percent__에 해당하는 내 자산을 스캔하는 데 20-30분이 소요됨',
          cntScanTime30To40:
            '__percent__에 해당하는 내 자산을 스캔하는 데 30-40분이 소요됨',
          cntScanTimeGt40:
            '__percent__에 해당하는 내 자산을 스캔하는 데 40분 이상이 소요됨',
          cntScanTimeLt10:
            '__percent__에 해당하는 내 자산을 스캔하는 데 0-10분이 소요됨',
        },
        value: {
          cntScanTime10To20:
            '__percent__(__value__)에 해당하는 내 자산을 스캔하는 데 10-20분이 소요됨',
          cntScanTime20To30:
            '__percent__(__value__)에 해당하는 내 자산을 스캔하는 데 20-30분이 소요됨',
          cntScanTime30To40:
            '__percent__(__value__)에 해당하는 내 자산을 스캔하는 데 30-40분이 소요됨',
          cntScanTimeGt40:
            '__percent__(__value__)에 해당하는 내 자산을 스캔하는 데 40분 이상이 소요됨',
          cntScanTimeLt10:
            '__percent__(__value__)에 해당하는 내 자산을 스캔하는 데 0-10분이 소요됨',
        },
      },
      AssetsByVulnSeverity: {
        description: '심각도별로 취약점을 분류한 내 자산을 나타냅니다',
        label: {
          critical: '__percent__(__value__) 취약점 상',
          moderate: '__percent__(__value__) 취약점 하',
          severe: '__percent__(__value__) 취약점 중',
          unknown: '__percent__(__value__) 취약점 알 수 없음',
        },
        name: '취약점 심각도별 자산',
        summary: {
          critical:
            '__percent__에 해당하는 내 자산의 취약점 심각도가 상으로 나타남',
          moderate:
            '__percent__에 해당하는 내 자산의 취약점 심각도가 하로 나타남',
          severe:
            '__percent__에 해당하는 내 자산의 취약점 심각도가 중으로 나타남',
          unknown:
            '__percent__에 해당하는 내 자산에 알려진 취약점이 감지되지 않음',
        },
        value: {
          critical:
            '__percent__(__value__)에 해당하는 내 자산의 취약점 심각도가 상으로 나타남',
          moderate:
            '__percent__(__value__)에 해당하는 내 자산의 취약점 심각도가 하로 나타남',
          severe:
            '__percent__(__value__)에 해당하는 내 자산의 취약점 심각도가 중으로 나타남',
          unknown:
            '__percent__(__value__)에 해당하는 내 자산에 알려진 취약점이 감지되지 않음',
        },
      },
      AssetsCriticalVuln: {
        description:
          '예외 처리되지 않았고 취약점 위험도가 상(CVSS 지수 8 이상)인 자산 수를 나타냅니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: '취약점 상인 자산',
        summary: {
          assetCount: '취약점 상',
        },
      },
      AssetsNewlyDiscoveredXDays: {
        description: '지정된 기간에 환경에서 새로 검색된 자산 수를 나타냅니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: '새로 검색된 자산',
        summary: {
          assetCount: '새로 검색된 취약성',
        },
      },
      AssetsWithActivelyExploitedVulnerabilities: {
        description:
          'Rapid7이 Rapid7 Lab의 하이젠버그 하니팟, 사고 대응 활동 및 신뢰할 수 있는 타사 정보를 활용하여 대부분의 가장 위험한 활성 익스플로이트 취약점 위협 피드를 치료했습니다. 이 카드는 이 취약점에 의해 영향을 받는 자산의 수를 보여줍니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: '잦은 공격 대상이 되는 취약점이 있는 자산',
        summary: {
          assetCount: '잦은 공격 대상이 되는 취약점이 있는 자산 포함',
        },
      },
      AssetsWithDefaultAccountVulns: {
        description:
          '기본 계정 사용과 관련된 취약점이 있는 자산의 수를 나타냅니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: '기본 계정 취약점이 있는 자산',
        summary: {
          assetCount: '기본 계정 취약점이 있는',
        },
      },
      AssetsWithKnownObsoleteOS: {
        description:
          '사용되지 않는 알려진 운영 체제에서 현재 실행되고 있는 자산의 비율입니다.',
        label: {
          assetCount: '사용되지 않는 운영 체제가 있는 자산',
          otherCount: '나머지 자산',
        },
        name: '사용되지 않는 운영 체제에서 실행 중인 자산',
        summary: {
          assetCount:
            '__percent__의 자산이 사용되지 않는 운영 체제에서 실행 중임',
          otherCount:
            '__percent__의 자산이 사용되지 않는 운영 체제에서 실행 중이 아님',
        },
        value: {
          assetCount:
            '사용되지 않는 운영 체제가 있는 __percent__ (__value__) 자산',
          otherCount: '__percent__(__value__) 나머지 자산',
        },
      },
      ChangeInNumberOfAssets: {
        description:
          '핵심 성능 지표를 모니터링할 수 있도록 총 자산 수 및 특정 기간에 발생한 이러한 수치의 변화를 나타냅니다.',
        label: {
          totalAssets: '전체 자산',
        },
        name: '전체 자산 동향',
        summary: {
          assetCount: '__value__(__percent__) 증가',
        },
      },
      ContainerCountsCard: {
        description: '자산 컨테이너 개수를 표시하는 카드',
        name: '개수',
      },
      CredentialSuccessCard: {
        description: '인증에 성공한 자산을 나타냅니다.',
        label: {
          cntCredentialFailure: '__percent__(__value__) 로그인 실패',
          cntCredentialSuccess: '__percent__(__value__) 로그인 성공',
          cntCredentialUnknown: '__percent__(__value__) 로그인이 시도되지 않음',
        },
        name: '인증 상태별 자산',
        summary: {
          cntCredentialFailure:
            '__percent__에 해당하는 내 자산이 로그인에 실패함',
          cntCredentialSuccess:
            '__percent__에 해당하는 내 자산이 로그인에 성공함',
          cntCredentialUnknown:
            '__percent__에 해당하는 내 자산이 로그인 시도를 하지 않음',
        },
        value: {
          cntCredentialFailure:
            '__percent__(__value__)에 해당하는 내 자산이 로그인에 실패함',
          cntCredentialSuccess:
            '__percent__(__value__)에 해당하는 내 자산이 로그인에 성공함',
          cntCredentialUnknown:
            '__percent__(__value__)에 해당하는 내 자산이 로그인 시도를 하지 않음',
        },
      },
      CredentialSuccessOverTime: {
        description:
          '시간 경과에 따라 자산에서의 자격 증명 검증 성공 또는 실패 관련 정보와 그래프를 나타내는 카드',
        label: {
          credentialFailedAssetCount: '$t(failed)',
          credentialSuccessAssetCount: '$t(successful)',
          credentialUnknownAssetCount: '$t(unknown)',
        },
        name: '시간 경과에 따른 자격 증명 검증 성공',
        value: {
          credentialFailedAssetCount:
            '$t(weekOf)<br/>$t(failed) __percent__ (__value__)',
          credentialSuccessAssetCount:
            '$t(weekOf)<br/>$t(successful) __percent__ (__value__)',
          credentialUnknownAssetCount:
            '$t(weekOf)<br/>$t(unknown) __percent__ (__value__)',
        },
        yAxisLabel: '$t(percentOfAssets)',
      },
      ExpiredSSLCertificatesCard: {
        description:
          '사용자 환경의 자산 중 현재 SSL 인증서가 만료된 자산의 수를 표시합니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: 'SSL 인증서가 만료된 자산',
        summary: {
          assetCount: 'SSL 인증서가 만료된',
        },
      },
      ExpiredVulnExceptionTableComponent: {
        description:
          '사용자 환경에서 최근에 만료된 취약점 예외 처리를 나타내는 카드입니다.',
        name: '최근에 만료된 취약점 예외 처리',
      },
      ExpiringSSLCertificatesCard: {
        description:
          '사용자 환경에서 SSL 인증서가 지정된 기간 내에 만료되도록 설정된 자산의 수를 나타냅니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: 'SSL 인증서 만료 예정 자산',
        summary: {
          assetCount: 'SSL 인증서 만료 예정',
        },
      },
      ExpiringVulnExceptionTableComponent: {
        description:
          '사용자 환경에서 곧 만료될 취약점 예외 처리를 나타내는 카드입니다.',
        name: '곧 만료될 예외 처리된 취약점',
      },
      ExploitableAssetsBySkillLevel: {
        description:
          '사용자의 환경에 있는 자산을 취약점을 익스플로이트하는 데 필요한 기술 수준을 기준으로 분석한 내용을 나타냅니다.',
        label: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__(__value__) 알려진 익스플로이트 없음',
          cntMinSkillLevelRankExpert: '__percent__ 전문가',
          cntMinSkillLevelRankIntermediate: '__percent__ 중급',
          cntMinSkillLevelRankNovice: '__percent__(__value__) 초급',
        },
        name: '기술 수준별 익스플로이트 가능 자산',
        summary: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__의 자산에 알려진 익스플로이트 없음',
          cntMinSkillLevelRankExpert:
            '__percent__의 자산을 전문가가 익스플로이트할 수 있음',
          cntMinSkillLevelRankIntermediate:
            '__percent__의 자산을 중급 기술 보유자가 익스플로이트할 수 있음',
          cntMinSkillLevelRankNovice:
            '__percent__의 자산을 초급 기술 보유자가 익스플로이트할 수 있음',
        },
        value: {
          cntMinSkillLevelRankDoesNotExist:
            '__percent__(__value__)의 자산에 알려진 익스플로이트 없음',
          cntMinSkillLevelRankExpert:
            '__percent__(__value__)의 자산을 전문가가 익스플로이트할 수 있음',
          cntMinSkillLevelRankIntermediate:
            '__percent__(__value__)의 자산을 중급 기술 보유자가 익스플로이트할 수 있음',
          cntMinSkillLevelRankNovice:
            '__percent__(__value__)의 자산을 초급 기술 보유자가 익스플로이트할 수 있음',
        },
      },
      ExploitableVulnByCVSSscore: {
        description:
          'CVSS 지수로 사용자 환경의 익스플로이트 가능 취약점 비율을 분석하므로 일반적인 표준에 따라 사용자 환경의 어떤 부분에서 위험이 높은지 파악할 수 있습니다.',
        name: 'CVSS 지수별 익스플로이트 가능 취약점',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      ExploitableVulnDiscoverByTotalRiskScore: {
        description:
          '최근 90일 내에 발견된 익스플로이트가 가능한 취약점을 총 위험 지수로 정렬하여 높음에서 낮음 순으로 표시합니다.',
        name: '총 위험 지수를 통해 새로 발견된 익스플로이트가 가능한 취약점',
      },
      ExploitableVulnerabilities: {
        description:
          '사용자 환경의 총 취약점 수 및 지정된 기간에 이러한 수치의 동향을 나타내는 카드입니다.',
        label: {
          count: '$t(vulns)',
        },
        name: '익스플로이트 가능 취약점 수',
        summary: {
          count: '익스플로이트 가능 취약점',
        },
      },
      ExploitableVulnerabilitiesBySeverity: {
        description:
          '사용자 환경에서 익스플로이트 가능한 취약점 비율 분석을 심각도 수준별로 나타냅니다.',
        name: '심각도에 따른 익스플로이트 가능 취약점',
        ...vulnerabilitiesBySeverityLabeling,
      },
      ExploitableVulnerabilityAgeByCVSS: {
        description:
          '사용자 환경에서 익스플로이트가 가능한 취약점이 검색된 시간, 위치가 CVSS 지수별로 강조 표시된 카드',
        name: 'CVSS 지수별 익스플로이트가 가능한 취약점이 검색된 날짜',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityDiscoveryDateBySeverity: {
        description:
          '사용자 환경에서 익스플로이트가 가능한 취약점이 검색된 시간, 위치가 CVSS 심각도별로 강조 표시된 카드',
        name: '심각도별 익스플로이트가 가능한 취약점이 검색된 날짜',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishAgeBySeverity: {
        description:
          '사용자 환경에서 익스플로이트가 가능한 취약점이 공개된 기간에 대한 세부 정보가 심각도별로 나와 있는 카드',
        name: '심각도별 익스플로이트가 가능한 취약점 공개 기간',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnerabilityPublishDateByCVSS: {
        description:
          '익스플로이트 가능 취약점 공개 날짜가 CVSS 지수별로 나열된 카드',
        name: 'CVSS 지수별 익스플로이트가 가능한 취약점 공개 기간',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      ExploitableVulnsBySkillLevel: {
        description:
          '사용자 환경의 취약점을 익스플로이트하는 데 필요한 기술 수준을 기준으로 분석한 내용을 나타냅니다.',
        label: {
          cntExpert: '__percent__ 전문가',
          cntIntermediate: '__percent__ 중급',
          cntNovice: '__percent__(__value__) 초급',
          cntSkillUnknown: '__percent__(__value__) 알려진 익스플로이트 없음',
        },
        name: '기술 수준별 익스플로이트 가능 취약점',
        summary: {
          cntExpert: '__percent__의 취약점을 전문가가 익스플로이트할 수 있음',
          cntIntermediate:
            '__percent__의 취약점을 중급 기술 보유자가 익스플로이트할 수 있음',
          cntNovice:
            '__percent__의 취약점을 초급 기술 보유자가 익스플로이트할 수 있음',
          cntSkillUnknown: '__percent__의 취약점에 알려진 익스플로이트 없음',
        },
        value: {
          cntExpert:
            '__percent__(__value__)의 취약점을 전문가가 익스플로이트할 수 있음',
          cntIntermediate:
            '__percent__(__value__)의 취약점을 중급 기술 보유자가 익스플로이트할 수 있음',
          cntNovice:
            '__percent__(__value__)의 취약점을 초급 기술 보유자가 익스플로이트할 수 있음',
          cntSkillUnknown:
            '__percent__(__value__)의 취약점에 알려진 익스플로이트 없음',
        },
      },
      MostCommonExploitableVulnComponent: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 취약점을 나타냅니다.',
        name: '가장 일반적인 익스플로이트 가능 취약점',
      },
      MostCommonExploitedVulnComponent: {
        description:
          'Rapid7이 Rapid7 Lab의 하이젠버그 하니팟, 사고 대응 활동 및 신뢰할 수 있는 타사 정보를 활용하여 대부분의 가장 위험한 활성 익스플로이트 취약점 위협 피드를 치료했습니다. 이 카드는 영향을 받는 자산 수 순위로 사용자 환경에서 이러한 취약점에 대한 세부 내용을 보여줍니다.',
        name: '가장 많이 발견된 활성 대상 취약점',
      },
      MostCommonExploitsComponent: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 익스플로이트를 나타냅니다.',
        name: '가장 많이 발견된 익스플로이트',
      },
      MostCommonMalwareKitsComponent: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 멀웨어 키트를 나타냅니다.',
        name: '가장 많이 발견된 멀웨어 키트',
      },
      MostCommonVulnComponent: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 취약점을 나타냅니다.',
        name: '가장 많이 발견된 취약성',
      },
      NewVsRemediatedVulnerabilities: {
        description:
          '주어진 날짜 이후에 해결된 취약점 결과, 새로운 취약점 결과 및 변경되지 않은 취약점 결과의 수를 비교하는 카드입니다.',
        label: {
          newFindings: '__percent__(__value__) 새 취약점 결과',
          remediatedFindings: '__percent__(__value__) 해결된 취약점 결과',
          unchangedFindings: '__percent__(__value__) 변경되지 않은 취약점 결과',
        },
        name: '새로운 및 해결된 취약점',
        summary: {
          newFindings: '__percent__새 취약점 결과',
          remediatedFindings: '__percent__해결된 취약점 결과',
          unchangedFindings: '__percent__변경되지않은 취약점 결과',
        },
        value: {
          newFindings: '__percent__(__value__) 새 취약점 결과',
          remediatedFindings: '__percent__(__value__) 해결된 취약점 결과',
          unchangedFindings: '__percent__(__value__) 변경되지 않은 취약점 결과',
        },
      },
      NumberOfConnectedAgentsComponent: {
        description:
          '사용자의 환경에 존재하며 연결된 에이전트가 있는 자산 수를 나타내는 카드입니다.',
        label: {
          assetCount: '$t(assets)',
        },
        name: '에이전트가 있는 자산의 수',
        summary: {
          assetCount: '연결된 에이전트 포함',
        },
      },
      ObsoleteSoftwareCard: {
        description:
          '네트워크에 있는 사용되지 않는/사용되는 자산을 나타내는 카드입니다.',
        label: {
          assetCount: '사용되지 않는 소프트웨어가 있는 자산',
          otherCount: '나머지 자산',
        },
        name: '사용되지 않는 소프트웨어에서 실행 중인 자산',
        summary: {
          assetCount:
            '__percent__의 자산에 사용되지 않는 알려진 소프트웨어가 설치됨',
          otherCount:
            '__percent__의 자산에 사용되지 않는 알려진 소프트웨어가 설치되지 않음',
        },
        value: {
          assetCount:
            '__percent__(__value__)의 자산에 사용되지 않는 알려진 <br/> 소프트웨어가 설치됨',
          otherCount:
            '__percent__(__value__)의 자산에 사용되지 않는 알려진 <br/> 소프트웨어가 설치되지 않음',
        },
      },
      ProjectsAtRiskCard: {
        description:
          '여전히 열려 있고 만료 날짜가 다가오고 있는 프로젝트의 수를 보여줍니다.',
        label: {
          totalElements: '프로젝트 종료 중',
        },
        name: '위험 프로젝트',
        summary: {
          totalElements: '',
        },
      },
      ProjectsMostRemainingWorkCard: {
        description:
          '해결되지 않은 문제 해결 항목의 수가 가장 많은 프로젝트를 나열합니다.',
        name: '남은 작업',
      },
      ProjectsMostRemainingWorkPercentCard: {
        description:
          '해결되지 않은 문제 해결 항목의 수가 가장 많은 프로젝트를 나열합니다.',
        name: '남은 작업 %',
      },
      ProjectsPastDueCard: {
        description: '기한이 초과한 프로젝트의 수를 보여줍니다.',
        label: {
          totalElements: '$t(projects)',
        },
        name: '기한 초과 프로젝트',
        summary: {
          totalElements: '은(는) 기한이 초과됨',
        },
      },
      ProjectsRecentlyClosedCard: {
        description: '최근 종료된 프로젝트의 수를 보여줍니다.',
        label: {
          totalElements: '프로젝트 종료됨',
        },
        name: '최근 종료 프로젝트',
        summary: {
          totalElements: '',
        },
      },
      RemediatedVulnerabilities: {
        description:
          '최근 30일 동안 사용자 환경에서 감소한 취약점을 나열합니다.',
        name: '가장 많이 해결된 취약점',
      },
      RemediatorsRequiringAssistance: {
        description:
          '기한이 초과한 프로젝트가 가장 많이 열려 있는 프로젝트 소유자를 나열합니다.',
        name: '문제 해결을 위해 지원 필요',
      },
      RiskVulnsCard: {
        description:
          '위험 및 취약점 수를 기준으로 정렬한 자산이 나와 있는 산점도 차트 표시',
        name: '위험 및 취약점별 자산',
        summary: {
          selected: '호스트 이름: __name__',
        },
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      TopRemediators: {
        description:
          '기한 내에 가장 많은 프로젝트가 종료된 프로젝트 소유자를 나열합니다.',
        name: '주요 문제 해결',
      },
      TopRiskiestAssetGroupsComponent: {
        description:
          '사용자 환경에서 위험 지수가 가장 높은 자산 그룹을 나열합니다.',
        name: '위험도가 가장 높은 주요 자산 그룹',
      },
      TopRiskiestAssetLocationsComponent: {
        description: '사용자 환경에서 총 위험도가 가장 높은 위치를 나열합니다.',
        name: '총 위험도가 가장 높은 자산 위치',
      },
      TopRiskiestAssetOwnersComponent: {
        description: '총 위험이 가장 높은 자산의 소유자를 나열합니다.',
        name: '위험도가 가장 높은 자산 소유자',
      },
      TopRiskiestAssetsComponent: {
        description: '사용자 환경에서 위험이 가장 높은 자산을 나열합니다.',
        name: '위험도가 가장 높은 자산',
      },
      TopRiskiestSitesComponent: {
        description:
          '사용자 환경에서 총 위험도가 가장 높은 사이트를 나열합니다.',
        name: '위험도가 가장 높은 사이트',
      },
      TotalVulnerabilities: {
        description:
          '특정한 시기에 사용자 환경에 있는 취약점 수의 변화를 나타내는 카드입니다.',
        label: {
          count: '$t(vulns)',
        },
        name: '취약점의 개수',
        summary: {
          count: '전체 취약점',
        },
      },
      TrendingVulnerabilities: {
        description:
          '최근 30일 동안 사용자 환경에서 보다 증가한 취약점을 나열합니다.',
        name: '주요 취약점 추세',
      },
      VulnByCVSSscore: {
        description:
          'CVSS 지수로 사용자 환경의 취약점 비율을 분석하므로 일반적인 표준에 따라 사용자 환경의 어떤 부분에서 위험이 높은지 파악할 수 있습니다.',
        name: 'CVSS 지수별 취약점',
        ...vulnerabilitiesByCvssScoreLabeling,
      },
      VulnDiscoverByTotalRiskScore: {
        description:
          '최근 90일 내에 발견된 취약점을 총 위험 지수로 정렬하여 높음에서 낮음 순으로 표시합니다.',
        name: '총 위험 지수를 통해 새로 발견된 익스플로이트가 가능한 취약점',
      },
      VulnRiskOverTime: {
        description:
          '사용자 환경의 취약점 위험 추세를 나타므로 시간에 따라 총 위험이 증가했는지 감소했는지 확인할 수 있습니다.',
        name: '시간에 따른 취약점 위험 지수',
        value: {
          riskScore: '$t(weekOf)<br/>$t(riskScoreLabel) __value__',
        },
        yAxisLabel: '$t(riskScoreLabel)',
      },
      VulnTrends: {
        description: '시간 경과에 따른 취약점 추세를 보여주는 카드입니다.',
        label: {
          cntCritical: '$t(critical)',
          cntModerate: '$t(moderate)',
          cntSevere: '$t(severe)',
        },
        name: '시간 경과에 따른 취약점 심각도별 자산',
        value: {
          cntCritical: '$t(weekOf)<br/>$t(critical) __percent__ (__value__)',
          cntModerate: '$t(weekOf)<br/>$t(moderate) __percent__ (__value__)',
          cntSevere: '$t(weekOf)<br/>$t(severe) __percent__ (__value__)',
        },
      },
      VulnerabilitiesBySeverity: {
        description:
          '사용자 환경의 취약점 비율 분석을 심각도 수준별로 나타냅니다.',
        name: '심각도에 따른 취약점',
        ...vulnerabilitiesBySeverityLabeling,
      },
      VulnerabilityAgeByCVSS: {
        description:
          '사용자 환경의 취약점이 검색된 시간, 위치가 CVSS 지수별로 강조 표시된 카드',
        name: 'CVSS 지수별 취약점 검색 날짜',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityDiscoveryDateBySeverity: {
        description:
          '사용자 환경의 취약점이 검색된 시간, 위치가 심각도별로 강조 표시된 카드',
        name: '심각도별 취약점 검색 날짜',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishAgeBySeverity: {
        description:
          '사용자 환경의 취약점이 공개된 기간에 대한 세부 정보가 심각도별로 나와 있는 카드',
        name: '심각도별 취약점 공개 기간',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: severityLabels,
        yAxisLabel: dayRangeLabels,
      },
      VulnerabilityPublishDateByCVSS: {
        description: '취약점 공개 날짜가 CVSS 지수별로 나열된 카드',
        name: 'CVSS 지수별 취약점 공개 기간',
        value: '__value__ $t(vulnerabilityFindings)',
        xAxisLabel: cvssScoreLabels,
        yAxisLabel: dayRangeLabels,
      },
      'petya-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) Petya에 대한 취약점',
        name: 'Petya 취약점 $t(assetsByComponent.OS.title)',
        summary: '__percent__에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      'petya-AssetsCriticalVuln': {
        description: 'Petya 취약점이 있는 사용자 환경 내 자산 수',
        label: {assetCount: '$t(assets)'},
        name: 'Petya 취약점이 있는 자산',
        summary: {assetCount: 'Petya 취약점 포함'},
      },
      'petya-MostCommonExploitsComponent': {
        description:
          '사용자 환경에서 Petya에 대한 $t(cards.mostCommonExploits.title)',
        name: 'Petya에 대한 $t(cards.mostCommonExploits.title)',
      },
      'petya-MostCommonVulnComponent': {
        description: '사용자 환경에서 가장 많이 발견된 Petya 취약점.',
        name: '가장 많이 발견된 Petya 취약점',
      },
      'petya-TotalVulnerabilities': {
        description: '사용자 환경에서 발견된 Petya 취약점 수입니다.',
        label: {count: 'Petya 취약점 결과'},
        name: 'Petya 취약점 수',
        summary: {count: ''},
      },
      'samba-AssetsByOS': {
        description:
          '$t(cards.assets.card.byOS.title) $t(sambaWithCve) 사용자 환경에서 발견됨',
        name: '$t(cards.assets.card.byOS.title) $t(sambaWithCve)',
        summary: '__percent__에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      'samba-ChangeInNumberOfAssets': {
        description: '$t(samba)에 취약한 자산',
        label: {
          totalAssets: 'Samba에 취약한 자산',
        },
        name: '자산 $t(sambaWithCve)',
        summary: {
          assetCount: '__value__(__percent__) 증가',
        },
      },
      'samba-MostCommonExploitsComponent': {
        description:
          '$t(sambaWithCve)에 대한 $t(cards.mostCommonExploits.title)',
        name: '$t(cards.mostCommonExploits.title) for $t(samba)',
      },
      'samba-TopRiskiestAssetsComponent': {
        description:
          '$t(samba)에 취약한 $t(cards.TopRiskiestAssetsComponent.name)',
        name:
          '$t(cardTemplates.TopRiskiestAssetsComponent.name) $t(sambaWithCve)',
      },
      'samba-TotalVulnerabilities': {
        description: '사용자 환경에서 $t(samba) 발견 수',
        label: {count: '$t(samba) $t(vulnerabilities)'},
        name: '$t(samba) 발견 수',
        summary: {count: ''},
      },
      'wannacry-AssetsByOS': {
        description: '$t(assetsByComponent.OS.title) WannaCry 취약점',
        name: 'WannaCry 취약점 $t(assetsByComponent.OS.title)',
        summary: '__percent__에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
        value:
          '__percent__(__value__)에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
      },
      'wannacry-AssetsCriticalVuln': {
        description: 'WannaCry 취약점이 있는 사용자 환경 내 자산 수',
        label: {assetCount: '$t(assets)'},
        name: 'WannaCry 취약점이 있는 자산',
        summary: {assetCount: 'WannaCry 취약점이 있는'},
      },
      'wannacry-MostCommonExploitsComponent': {
        description:
          '사용자 환경에서 WannaCry에 대한 $t(cards.mostCommonExploits.title)',
        name: 'WannaCry에 대한 $t(cards.mostCommonExploits.title)',
      },
      'wannacry-MostCommonVulnComponent': {
        description: '사용자 환경에서 가장 많이 발견된 WannaCry 취약점.',
        name: '가장 많이 발견된 WannaCry 취약점',
      },
      'wannacry-TotalVulnerabilities': {
        description: '사용자 환경에서 발견된 WannaCry 취약점 수입니다.',
        label: {count: 'WannaCry 취약점 결과'},
        name: 'WannaCry 취약점 수',
        summary: {count: ''},
      },
    },
    cards: {
      assets: {
        card: {
          agents: {
            byOS: {
              description:
                '운영 체제별 연결 에이전트가 포함된 자산에 대한 분석이 나와 있는 카드입니다.',
              summary:
                '에 해당하는 내 에이전트 포함 자산이 __os__ 운영 체제에서 실행됨',
              title: '운영 체제별 에이전트 포함 자산',
            },
            comingSoon: '지원 예정',
            couldNotDownload:
              '에이전트 소프트웨어 다운로드 도중 오류가 발생했습니다.',
            downloadBtnLoading: '다운로드 중:',
            downloadLinuxText: 'Linux 에이전트 다운로드',
            downloadMacText: 'Mac 에이전트 다운로드',
            downloadPageCategory: '에이전트 관리',
            downloadPageTitle: '에이전트 다운로드 및 관리 페이지',
            downloadWindowsText: 'Windows 에이전트 다운로드',
            featureOne: {
              desc: 'Rapid7 에이전트는 기타 Rapid7 제품을 통합합니다.',
              number: '1',
              title: '하나의 에이전트로 전체를 관리',
            },
            featureThree: {
              desc:
                '가볍고 빠르게 처리되도록 설계되어 사용자가 에이전트를 알아채지 못합니다.',
              number: '3',
              title: '소형 설치 규모',
            },
            featureTwo: {
              desc:
                '사용자가 온라인에 접속할 때마다 동기화를 수행하는 상자에서 바로 유용한 데이터를 얻을 수 있습니다.',
              number: '2',
              title: '사용자가 필요할 때 제공되는 데이터',
            },
            installInstructions: {
              installation: '설치용',
              installsTo: '에이전트 설치 대상:',
              linux: {
                install: './agent_installer.sh install_start',
                installsTo1: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '에이전트는 플랫폼의 SCM(systemctl, systemd 등) 또는 설치 관리자를 통해 관리될 수 있습니다:',
                installsTo3: './agent_installer.sh status',
                uninstall: './agent_installer.sh uninstall',
              },
              localInstallation: '로컬 설치용',
              mac: {
                install:
                  '.pkg를 두 번 클릭하여 UI 설치 관리자를 통해 이동합니다.',
                installsTo: '/opt/rapid7/ir_agent/',
                installsTo2:
                  '에이전트는 launchctl를 통해 com.rapid7.ir_agent로 관리될 수 있습니다.',
                silentInstall: 'sudo installer -pkg <.pkg> -target /',
                uninstall: 'sudo /opt/rapid7/ir_agent/uninstall.sh -f',
              },
              multipleInstallations: '다중 설치용',
              silentInstall: '자동 설치용',
              silentLocalInstall: '자동 로컬 설치용',
              uninstall: '제거용',
              win: {
                installsTo: 'C:\\Program Files\\Rapid7\\Endpoint Agent\\',
                installsTo2:
                  '에이전트는 ‘Rapid7 Endpoint Agent’ 서비스를 통해 관리될 수 있습니다.',
                local:
                  '.msi를 두 번 클릭하여 UI 설치 관리자를 통해 이동합니다.',
                multiple:
                  '여러 자산에 에이전트를 설치하려면 SCM(시스템 센터 구성 관리자) 등의 엔드포인트 관리 도구를 사용하십시오. GPO(그룹 정책 개체)를 사용하려면 Network Logon Share(활성 디렉터리)에 MSI 설치 관리자를 배치하십시오. 새 GPO를 생성합니다.',
                silentLocal: 'msiexec /i agentinstaller-x86_x64.msi /quiet /qn',
              },
            },
            linuxAgent: 'Linux 에이전트',
            macAgent: 'Mac 에이전트',
            numberConnected: {
              description:
                '사용자의 환경에 존재하며 연결된 에이전트가 있는 자산 수를 나타내는 카드입니다.',
              subTitle: '자산',
              summary: '연결된 에이전트 포함',
              title: '에이전트가 있는 자산의 수',
            },
            supportText:
              '지원이 필요하십니까? <a class="support-link">고객 지원</a>에 문의해 주십시오.',
            winAgent: 'Windows 에이전트',
          },
          byLastScanDate: {
            description:
              '스캔 시점을 기준으로 분류된 자산의 그래프를 표시합니다.',
            scanDateIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '에 해당하는 내 자산이 __days__일 동안 스캔되지 않음.',
            title: '마지막 스캔 날짜별 자산',
            totalAssets: '스캔한 자산',
          },
          byOS: {
            description: '운영 체제별 자산에 대한 분석이 나와 있는 카드입니다.',
            summary: '에 해당하는 내 자산이 __os__ 운영 체제에서 실행됨',
            title: '운영 체제별 자산',
            unknownOS: '알 수 없는 운영 체제',
          },
          byRiskDelta: {
            description:
              '사용자 환경에서 위험 지수가 가장 많이 증가한 자산이 강조 표시된 카드입니다.',
            title: '30일간 위험이 증가한 자산',
          },
          bySkillLevel: {
            description:
              '사용자의 환경에 있는 자산을 취약점을 익스플로이트하는 데 필요한 기술 수준을 기준으로 분석한 내용을 나타냅니다.',
            expertSummary:
              '에 해당하는 사용자 환경 내의 자산을 전문가가 익스플로이트 가능',
            intermediateSummary:
              '에 해당하는 사용자 환경 내의 자산을 중급자가 익스플로이트 가능',
            legend: {
              expert: '고급',
              intermediate: '중급',
              novice: '초급',
              unknown: '알려진 익스플로이트 없음',
            },
            noviceSummary:
              '에 해당하는 사용자 환경 내의 자산을 초급자가 익스플로이트 가능',
            title: '기술 수준별 익스플로이트 가능 자산',
            unknownSummary:
              '에 해당하는 사용자 환경 내의 자산이 알려진 익스플로이트가 없음',
          },
          byTotalScanTime: {
            description: '스캔 시간으로 분류한 자산의 그래프를 표시합니다.',
            scannedIn: "$t(timeUnits.__timeUnit__,  {'count': __time__})",
            summary: '에 해당하는 내 자산을 스캔하는 데 __mins__분이 소요됨.',
            title: '총 스캔 시간별 자산',
            totalAssets: '스캔한 자산',
            totalScanTime: '총 스캔 시간',
          },
          byVulnSeverity: {
            criticalSummary:
              '에 해당하는 내 자산의 취약점 심각도가 상으로 나타남',
            description: '심각도별로 취약점을 분류한 내 자산을 나타냅니다',
            legend: {
              critical: '취약점 상',
              moderate: '취약점 하',
              severe: '취약점 중',
              unknown: '알 수 없는 취약점',
            },
            moderateSummary:
              '에 해당하는 내 자산의 취약점 심각도가 중으로 나타남',
            severeSummary:
              '에 해당하는 내 자산의 취약점 심각도가 중으로 나타남',
            title: '취약점 심각도별 자산',
            unknownSummary:
              '에 해당하는 내 자산에 알려진 취약점이 감지되지 않음',
          },
          changeInNumber: {
            description:
              '핵심 성능 지표를 모니터링할 수 있도록 총 자산 수 및 특정 기간에 발생한 이러한 수치의 변화를 나타냅니다.',
            subTitle: '전체 자산',
            summary: ' __difference__ (__percentDifference__% change)',
            title: '전체 자산 동향',
          },
          defaultAccountVulns: {
            description:
              '기본 계정 사용과 관련된 취약점이 있는 자산의 수를 나타냅니다.',
            subTitle: '자산',
            summary: '기본 계정 취약점이 있는',
            title: '기본 계정 취약점이 있는 자산',
          },
          knownObsoleteOS: {
            description:
              '사용되지 않는 알려진 운영 체제에서 현재 실행되고 있는 자산의 비율입니다.',
            subTitle: '사용되지 않는 운영 체제에서 실행 중인 자산',
            title: '사용되지 않는 운영 체제에서 실행 중인 자산',
          },
          notScanned: {
            description: '특정 기간에 스캔되지 않은 자산 수를 나타냅니다.',
            subTitle: '자산',
            summary: '스캔되지 않음',
            title: '최근 스캔되지 않은 자산',
          },
          owners: {
            violatingPolicy: {
              description: '회사 정책에 위반된 자산이 가장 많은 소유자입니다.',
              title: '회사 정책 위반 자산이 가장 많은 소유자',
            },
          },
          violatingPolicy: {
            description: '회사 정책에 위반된 자산이 가장 많은 위치입니다.',
            title: '회사 정책 위반 자산이 가장 많은 위치',
          },
        },
        description: '사용자 환경에서 위험이 가장 높은 자산을 나열합니다.',
        donutTitle: '위험도가 가장 높은 자산',
        drilldown: {
          remediation: {
            assigneesPlaceholder: '프로젝트를...에 추가',
            clickHereToViewNewProject:
              '새 프로젝트를 보려면 여기를 클릭하십시오.',
            createDynamicProject: '동적 문제 해결 프로젝트 만들기',
            createDynamicProjectHint: '필터별로 정의된 새로운 프로젝트 만들기',
            createStaticProject: '정적 문제 해결 프로젝트 만들기',
            createStaticProjectHint:
              '선택한 자산을 추가하여 정적 프로젝트 만들기',
            descriptionPlaceholder: '프로젝트에 대한 설명',
            errorNotification:
              '문제 해결 프로젝트 저장 중 오류가 발생했습니다. 나중에 다시 시도하십시오.',
            manageProjects: '프로젝트 관리',
            remediate: '문제 해결',
            selectedCount: '기록이 __count__개 선택되었습니다.',
            successNotification:
              '문제 해결 프로젝트 __title__이(가) 생성되었습니다. __link__.',
            titlePlaceholder: '프로젝트 이름',
            titleRequired: '제목은 비워 둘 수 없음',
          },
        },
        newlyDiscovered: {
          description:
            '지정된 기간에 환경에서 새로 검색된 자산 수를 나타냅니다.',
          subTitle: '자산',
          summary: '새로 검색된 취약성',
          title: '새로 검색된 자산',
        },
        title: '위험도가 가장 높은 자산',
        vulnerabilities: {
          critical: {
            description:
              '예외 처리되지 않았고 취약점 위험도가 상(CVSS 지수 8 이상)인 자산 수를 나타냅니다.',
            subTitle: '자산',
            summary: '취약점 상',
            title: '취약점 상인 자산',
          },
          dataFetchFailed:
            '취약점을 검색하지 못했습니다. 나중에 다시 시도하십시오.',
          nonCritical: {
            summary: '에 해당하는 내 자산에 심각도 상인 취약점이 없음',
          },
        },
      },
      counts: {
        assetGroupsCount: '자산 그룹',
        assetSitesCount: '사이트',
        assetTagsCount: '태그',
      },
      credential: {
        'success-over-time': '시간 경과에 따른 자격 증명 검증 성공',
        successCard: {
          chart: {
            credentialFailedAssetCount: '에 해당하는 내 자산이 로그인에 실패함',
            credentialSuccessAssetCount:
              '에 해당하는 내 자산이 로그인에 성공함',
            credentialUnknownAssetCount:
              '에 해당하는 내 자산이 로그인 시도를 하지 않음',
            legend: {
              credentialFailedAssetCount: '실패한 로그인',
              credentialSuccessAssetCount: '성공한 로그인',
              credentialUnknownAssetCount: '시도한 로그인 없음',
            },
          },
          description:
            '네트워크에서의 자격 증명 검증 성공/실패 비율을 상세히 나타내는 카드입니다.',
          summary: {
            credentialFailedAssetCount: '에 해당하는 내 자산이 로그인에 실패함',
            credentialSuccessAssetCount:
              '에 해당하는 내 자산이 로그인에 성공함',
            credentialUnknownAssetCount:
              '에 해당하는 내 자산이 로그인 시도를 하지 않음',
          },
          title: '자산에 대한 인증 상태',
        },
      },
      'credential-success': {
        description: '인증에 성공한 자산을 나타냅니다.',
        name: '인증 상태별 자산',
      },
      'credential-success-over-time': {
        description:
          '시간 경과에 따라 자산에서의 자격 증명 검증 성공 또는 실패 관련 정보와 그래프를 나타내는 카드',
        name: '시간 경과에 따른 자격 증명 검증 성공',
      },
      expired: {
        ssl: {
          certificatesCard: {
            description:
              '사용자 환경의 자산 중 현재 SSL 인증서가 만료된 자산의 수를 표시합니다.',
            subTitle: '자산',
            summary: 'SSL 인증서가 만료된',
            title: 'SSL 인증서가 만료된 자산',
          },
        },
      },
      expiredVulnException: {
        description:
          '사용자 환경에서 최근에 만료된 취약점 예외 처리를 나타내는 카드입니다.',
        title: '최근에 만료된 취약점 예외 처리',
      },
      expiring: {
        ssl: {
          certificatesCard: {
            description:
              '사용자 환경에서 SSL 인증서가 지정된 기간 내에 만료되도록 설정된 자산의 수를 나타냅니다.',
            subTitle: '자산',
            summary: 'SSL 인증서 만료 예정',
            title: 'SSL 인증서 만료 예정 자산',
          },
        },
      },
      expiringVulnException: {
        description:
          '사용자 환경에서 곧 만료될 취약점 예외 처리를 나타내는 카드입니다.',
        title: '곧 만료될 예외 처리된 취약점',
      },
      exploitableVulnByCVSSScore: {
        description:
          'CVSS 지수로 사용자 환경의 익스플로이트 가능 취약점 비율을 분석하므로 일반적인 표준에 따라 사용자 환경의 어떤 부분에서 위험이 높은지 파악할 수 있습니다.',
        legend: '__from__-__to__',
        summary:
          '의 익스플로이트 가능 취약점이 __from__ 에서 __to__ 사이의 CVSS 지수가 있음',
        title: 'CVSS 지수별 익스플로이트 가능 취약점',
      },
      location: {
        description: '사용자 환경에서 총 위험도가 가장 높은 위치를 나열합니다.',
        title: '총 위험도가 가장 높은 자산 위치',
      },
      mostCommonExploitableVuln: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 취약점을 나타냅니다.',
        title: '가장 일반적인 익스플로이트 가능 취약점',
      },
      mostCommonExploits: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 익스플로이트를 나타냅니다.',
        title: '가장 많이 발견된 익스플로이트',
      },
      mostCommonMalwareKits: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 멀웨어 키트를 나타냅니다.',
        title: '가장 많이 발견된 멀웨어 키트',
      },
      mostCommonVuln: {
        description:
          '영향을 받는 자산 수에 근거해 사용자 환경에서 가장 일반적인 취약점을 나타냅니다.',
        title: '가장 많이 발견된 취약성',
      },
      obsolete: {
        osCard: {
          chart: {
            assetCount: '사용되지 않는 운영 체제 자산',
            totalAssets: '나머지 자산',
          },
          description:
            '사용되지 않는 알려진 운영 체제에서 현재 실행되고 있는 자산의 비율입니다.',
          summary: {
            nonObsolete: '의 자산이 사용되는 운영 체제에서 실행 중임',
            obsolete: '의 자산이 사용되지 않는 운영 체제에서 실행 중임',
          },
          title: '사용되지 않는 운영 체제에서 실행 중인 자산',
        },
        softwareCard: {
          chart: {
            assetCount: '사용되지 않는 소프트웨어 자산',
            totalAssets: '나머지 자산',
          },
          description:
            '네트워크에 있는 사용되지 않는/사용되는 자산을 나타내는 카드입니다.',
          summary: {
            nonObsolete:
              '의 자산에 사용되지 않는 알려진 소프트웨어가 설치되지 않음',
            obsolete: '의 자산에 사용되지 않는 알려진 소프트웨어가 설치됨',
          },
          title: '사용되지 않는 소프트웨어에서 실행 중인 자산',
        },
      },
      owner: {
        description: '총 위험이 가장 높은 자산의 소유자를 나열합니다.',
        title: '위험도가 가장 높은 자산 소유자',
      },
      projectsAtRisk: {
        description:
          '여전히 열려 있고 만료 날짜가 다가오고 있는 프로젝트의 수를 보여줍니다.',
        subTitle: '프로젝트 종료 중',
        summary: '',
        title: '위험 프로젝트',
      },
      projectsMostRemainingWork: {
        description:
          '해결되지 않은 문제 해결 항목의 수가 가장 많은 프로젝트를 나열합니다.',
        title: '남은 작업',
      },
      projectsMostRemainingWorkPercent: {
        description:
          '해결되지 않은 문제 해결 항목의 수가 가장 많은 프로젝트를 나열합니다.',
        title: '남은 작업 %',
      },
      projectsPastDue: {
        description: '기한이 초과한 프로젝트의 수를 보여줍니다.',
        subTitle: '프로젝트',
        summary: '은(는) 기한이 초과됨',
        title: '기한 초과 프로젝트',
      },
      projectsRecentlyClosed: {
        description: '최근 종료된 프로젝트의 수를 보여줍니다.',
        subTitle: '프로젝트 종료됨',
        summary: '',
        title: '최근 종료 프로젝트',
      },
      remediatedVulnerabilities: {
        description:
          '최근 30일 동안 사용자 환경에서 감소한 취약점을 나열합니다.',
        title: '가장 많이 해결된 취약점',
      },
      remediationProgressCard: {
        assignees: {
          all: '모든 할당 대상',
          email: '이메일',
        },
        confirm: '확인',
        dates: {
          all: '모든 시간',
          custom: '사용자 정의',
          lastMonth: '지난달',
          lastWeek: '지난주',
          thisMonth: '이번 달',
          thisWeek: '이번 주',
        },
        endDate: '종료일',
        noProjectsCreated: '아직 생성된 프로젝트 없음',
        progress: '진행',
        projectStatus: {
          complete: '완료',
          completed: '완료',
          inProgress: '진행 중',
          incomplete: '미완료',
          notStarted: '시작되지 않음',
        },
        projects: '프로젝트',
        recentProjects: '최근 프로젝트',
        startDate: '시작일',
        task: '작업',
        title: '문제 해결 프로젝트 진행',
      },
      remediatorsRequiringAssistance: {
        description:
          '기한이 초과한 프로젝트가 가장 많이 열려 있는 프로젝트 소유자를 나열합니다.',
        title: '문제 해결을 위해 지원 필요',
      },
      'risk-vulns-card': {
        description:
          '위험 및 취약점 수를 기준으로 정렬한 자산이 나와 있는 산점도 차트 표시',
        name: '위험 및 취약점별 자산',
      },
      riskOverTimeCard: {
        allTime: '모든 시간',
        custom: '사용자 정의',
        riskScore: '위험 지수',
        thisMonth: '이번 달',
        thisWeek: '이번 주',
        time: '시간',
        title: '시간에 따른 위험',
      },
      riskVsVulnerabilities: {
        hostname: '호스트 이름: __name__',
        ipAddress: 'IP 주소',
        riskScore: '위험 지수',
        title: '위험 및 취약점별 자산',
        vulnerabilities: '취약점',
      },
      'scan-card': {
        description:
          '실패, 일시 중지 및 완료된 스캔의 수를 비롯해 사용자 환경의 모든 스캔에 대한 요약 표시',
        name: '스캔',
      },
      scanCard: {
        complete: '완료',
        drilldownTitle: '스캔',
        failed: '실패',
        inProgress: '진행 중',
        paused: '일시 중지',
        subTitle: '지난 30일',
        table: {
          assets: '자산',
          siteName: '사이트 이름',
          startDate: '시작일',
          status: '상태',
          vulnerabilities: '취약점',
        },
        title: '스캔',
      },
      sites: {
        riskiest: '위험도가 가장 높은 사이트',
        title: '위험도가 가장 높은 사이트',
      },
      'top-riskiest-asset-groups': {
        description:
          '사용자 환경에서 위험 지수가 가장 높은 자산 그룹을 나열합니다.',
        name: '위험도가 가장 높은 주요 자산 그룹',
      },
      'top-riskiest-assets': {
        description: '사용자 환경에서 위험이 가장 높은 자산을 나열합니다.',
        name: '위험도가 가장 높은 자산',
      },
      'top-riskiest-sites': {
        description:
          '사용자 환경에서 총 위험도가 가장 높은 사이트를 나열합니다.',
        name: '위험도가 가장 높은 사이트',
      },
      topRemediators: {
        description:
          '기한 내에 가장 많은 프로젝트가 종료된 프로젝트 소유자를 나열합니다.',
        title: '주요 문제 해결',
      },
      trendingVulnerabilities: {
        description:
          '최근 30일 동안 사용자 환경에서 보다 증가한 취약점을 나열합니다.',
        title: '주요 취약점 추세',
      },
      vulnByCVSSScore: {
        description:
          'CVSS 지수로 사용자 환경의 취약점 비율을 분석하므로 일반적인 표준에 따라 사용자 환경의 어떤 부분에서 위험이 높은지 파악할 수 있습니다.',
        legend: '__from__-__to__',
        summary: '의 취약점이 __from__ 에서 __to__ 사이의 CVSS 지수가 있음',
        title: 'CVSS 지수별 취약점',
      },
      vulnByRiskScore: {
        description:
          '위험 지수별로 사용자 환경에 있는 모든 취약점의 비율을 나타내는 카드입니다.',
        legend: '__from__-__to__',
        summary: '의 취약점이 __from__ 와 __to__사이의 위험 지수가 있음',
        summaryOver900: '에 해당하는 취약점의 위험 지수가 900을 초과함',
        title: '위험 지수별 취약점',
      },
      vulnerabilities: {
        ageByCVSS: {
          categories: {
            'age-range-1': '0-29일',
            'age-range-2': '30-59일',
            'age-range-3': '60-90일',
            'age-range-4': '90일 초과',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description:
            '사용자 환경의 취약점이 검색된 시간, 위치가 CVSS 지수별로 강조 표시된 카드',
          title: 'CVSS 지수별 취약점 검색 날짜',
        },
        ageBySeverity: {
          categories: {
            'age-range-1': '0-29일',
            'age-range-2': '30-59일',
            'age-range-3': '60-90일',
            'age-range-4': '90일 초과',
            critical: '위험',
            moderate: '보통',
            severe: '심각',
          },
          description:
            '사용자 환경에 있는 취약점의 평균 수명을 심각도별로 나타내는 카드',
          title: '심각도별 평균 취약점 기간',
        },
        bySkillLevel: {
          description:
            '사용자 환경의 취약점을 익스플로이트하는 데 필요한 기술 수준을 기준으로 분석한 내용을 나타냅니다.',
          expertSummary: '의 취약점을 전문가가 익스플로이트할 수 있음',
          intermediateSummary: '의 취약점을 중급자가 익스플로이트할 수 있음',
          legend: {
            expert: '고급',
            intermediate: '중급',
            novice: '초급',
            unknown: '알려진 익스플로이트 없음',
          },
          noviceSummary: '의 취약점을 초급자가 익스플로이트할 수 있음',
          title: '기술 수준별 익스플로이트 가능 취약점',
          unknownSummary:
            '에 해당하는 사용자 환경 내의 취약점에 알려진 익스플로이트가 없음',
        },
        bySkillLevelOverTime: {
          description:
            '사용자 환경의 모든 취약점을 시간에 따른 심각도별로 나타내는 카드입니다.',
          title: '시간에 따른 기술 수준별 익스플로이트 가능 취약점',
        },
        byVulnSeverity: {
          criticalSummary: '에 해당하는 귀하의 취약점이 심각도 상임',
          description:
            '사용자 환경의 취약점 비율 분석을 심각도 수준별로 나타냅니다.',
          legend: {
            critical: '취약점 상',
            moderate: '취약점 하',
            severe: '취약점 중',
            unknown: '알 수 없음',
          },
          moderateSummary: '에 해당하는 귀하의 취약점이 심각도 하임',
          severeSummary: '에 해당하는 귀하의 취약점이 심각도 중임',
          title: '심각도에 따른 취약점',
        },
        card: {
          exploitable: {
            description:
              '사용자 환경의 총 취약점 수 및 지정된 기간에 이러한 수치의 동향을 나타내는 카드입니다.',
            subTitle: '익스플로이트 가능 취약점',
            title: '익스플로이트 가능 취약점 수',
          },
          totalNumber: {
            description:
              '특정한 시기에 사용자 환경에 있는 취약점 수의 변화를 나타내는 카드입니다.',
            subTitle: '전체 취약점',
            summary: ' __difference__ (__percentDifference__% change)',
            title: '취약점의 개수',
          },
        },
        detail: {
          entity: {
            cvssScore: 'CVSS',
            dateModified: '수정됨',
            datePublished: '공개',
            severity: '심각도',
            title: '제목',
            vulnId: '취약점 ID',
          },
          title: '취약점 정보',
          vulnInstances: {
            dataFetchFailed: '취약점 인스턴스를 검색하지 못했습니다.',
          },
        },
        discoveryByTotalRiskScore: {
          description:
            '최근 90일 내에 발견된 취약점을 총 위험 지수로 정렬하여 높음에서 낮음 순으로 표시합니다.',
          title: '총 위험 지수를 통해 새로 발견된 익스플로이트가 가능한 취약점',
        },
        discoveryDateBySeverity: {
          categories: {
            'age-range-1': '0-29일',
            'age-range-2': '30-59일',
            'age-range-3': '60-90일',
            'age-range-4': '90일 초과',
            critical: '위험',
            moderate: '보통',
            severe: '심각',
          },
          description:
            '사용자 환경의 취약점이 검색된 시간, 위치가 심각도별로 강조 표시된 카드',
          title: '심각도별 취약점 검색 날짜',
        },
        exploitable: {
          ageByCVSS: {
            description:
              '사용자 환경에서 익스플로이트가 가능한 취약점이 검색된 시간, 위치가 CVSS 지수별로 강조 표시된 카드',
            title: 'CVSS 지수별 익스플로이트가 가능한 취약점이 검색된 날짜',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
          ageBySeverity: {
            description:
              '사용자 환경에 있는 익스플로이트가 가능한 취약점의 평균 수명을 심각도별로 나타내는 카드',
            title: '심각도별 익스플로이트가 가능한 취약점 평균',
          },
          byVulnSeverity: {
            criticalSummary:
              '에 해당하는 익스플로이트 가능 취약점의 심각도가 상임',
            description:
              '사용자 환경에서 익스플로이트 가능한 취약점 비율 분석을 심각도 수준별로 나타냅니다.',
            legend: {
              critical: '고위험 익스플로이트 가능 취약점',
              moderate: '하위험 익스플로이트 가능 취약점',
              severe: '중위험 익스플로이트 가능 취약점',
              unknown: '알 수 없음',
            },
            moderateSummary:
              '에 해당하는 익스플로이트 가능 취약점의 심각도가 하임',
            severeSummary:
              '에 해당하는 익스플로이트 가능 취약점의 심각도가 중임',
            title: '심각도에 따른 익스플로이트 가능 취약점',
          },
          discoveryByTotalRiskScore: {
            description:
              '최근 90일 내에 발견된 익스플로이트가 가능한 취약점을 총 위험 지수로 정렬하여 높음에서 낮음 순으로 표시합니다.',
            title:
              '총 위험 지수를 통해 새로 발견된 익스플로이트가 가능한 취약점',
          },
          discoveryDateBySeverity: {
            description:
              '사용자 환경에서 익스플로이트가 가능한 취약점이 검색된 시간, 위치가 CVSS 심각도별로 강조 표시된 카드',
            title: '심각도별 익스플로이트가 가능한 취약점이 검색된 날짜',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishAgeBySeverity: {
            description:
              '사용자 환경에서 익스플로이트가 가능한 취약점이 공개된 기간에 대한 세부 정보가 심각도별로 나와 있는 카드',
            title: '심각도별 익스플로이트가 가능한 취약점 공개 기간',
            xAxisLabel: severityLabels,
            yAxisLabel: dayRangeLabels,
          },
          publishDateByCVSS: {
            description:
              '익스플로이트 가능 취약점 공개 날짜가 CVSS 지수별로 나열된 카드',
            title: 'CVSS 지수별 익스플로이트가 가능한 취약점 공개 기간',
            xAxisLabel: cvssScoreLabels,
            yAxisLabel: dayRangeLabels,
          },
        },
        introducedLastWeek: {
          description:
            '지난 주에 사용자의 네트워크에 발생한 새로운 취약점을 위험 지수별로 나타내는 카드입니다.',
          title: '위험 지수별 새로운 취약점',
        },
        publishAgeBySeverity: {
          categories: {
            'age-range-1': '0-29일',
            'age-range-2': '30-59일',
            'age-range-3': '60-90일',
            'age-range-4': '90일 초과',
            critical: '위험',
            moderate: '보통',
            severe: '심각',
          },
          description:
            '사용자 환경의 취약점이 공개된 기간에 대한 세부 정보가 심각도별로 나와 있는 카드',
          title: '심각도별 취약점 공개 기간',
        },
        publishDateByCVSS: {
          categories: {
            'age-range-1': '0-29일',
            'age-range-2': '30-59일',
            'age-range-3': '60-90일',
            'age-range-4': '90일 초과',
            'cvss-range-1': '0.1-3.9',
            'cvss-range-2': '4.0-6.9',
            'cvss-range-3': '7.0-10',
          },
          description: '취약점 공개 날짜가 CVSS 지수별로 나열된 카드',
          title: 'CVSS 지수별 취약점 공개 기간',
        },
        remediated: {
          description:
            '위험 지수에 가장 큰 영향을 미치고 사용자의 네트워크에서 적용 가능한 문제 해결이 나열되어 있는 카드입니다.',
          title: '위험 지수별로 완료된 최근의 문제 해결',
        },
        riskScoreOverTime: {
          cardTitle: '시간에 따른 취약점 위험 지수',
          description:
            '사용자 환경의 취약점 위험 추세를 나타므로 시간에 따라 총 위험이 증가했는지 감소했는지 확인할 수 있습니다.',
          name: '시간에 따른 취약점 위험 지수',
        },
      },
    },
    cardsLabel: '카드',
    category: '범주',
    certainity: '확실성',
    certainty: '확실성',
    chart: {
      loading: '차트를 로딩 중입니다.',
      noData: '이 차트를 표시할 충분한 데이터가 없습니다.',
    },
    class: '등급',
    close: '닫기',
    closed: '폐쇄',
    comingSoon: '지원 예정',
    comparison: {
      cancelText: '비교 취소',
      compare: '비교',
      errorMessage: '비교할 유효한 날짜 두 개를 선택하십시오.',
      failedDataFetch:
        '비교 데이터를 가져오지 못했습니다. 나중에 다시 시도하십시오.',
      fromDate: '시작 날짜',
      metricAdded: '추가된 __name__',
      metricChange: '__name__ 변경',
      metricPrimarySubTitle: '선택한 두 스캔의 총 __name__',
      metricRemediated: '해결된 __name__',
      metricUnchanged: '변경되지 않은 __name__',
      text: '비교 - 두 개의 스캔을 비교하여 변경 사항 확인',
      toDate: '종료일',
    },
    configure: '구성',
    confirm: '확인',
    confirmLabel: '확인',
    'container-counts': {
      description: '자산 컨테이너 개수를 표시하는 카드',
      name: '개수',
    },
    continue: '계속',
    copy: '복사',
    count: '수',
    cpe: 'CPE',
    createdOn: '생성일',
    critical: '상',
    cvss: 'CVSS',
    cvssScore: 'CVSS 지수',
    dashboard: {
      cannotBeEmpty: '대시보드 이름을 비워 둘 수 없음',
      nameInUse: '이 이름은 이미 사용 중입니다',
      tooLong: '__length__자의 최대 문자수가 초과됨',
    },
    dashboardDescription: '$t(dashboardLabel) 설명',
    dashboardDropdown: {
      allMyDashboards: '내 대시보드 전체',
      allTemplates: 'R7 라이브러리에서 자세한 내용 참조',
      createDashboard: '새 대시보드 생성',
      dashboardTemplates: 'Rapid7이 추천하는 대시보드 템플릿',
      myDashboards: '내 대시보드',
    },
    dashboardLabel: '대시보드',
    dashboardLibrary: {
      categoryName: {
        allMyDashboards: '$t(dashboardDropdown.allMyDashboards)',
        allTemplates: '모든 대시보드 템플릿',
        asset: '자산 템플릿',
        changed: '변경 사항 템플릿',
        executive: '요약 템플릿',
        ownedDashboards: '내 소유',
        scans: '스캔 및 운영 템플릿',
        sharedDashboards: '나와 공유',
        vulnerability: '취약점 템플릿',
      },
      dashboardTemplates: 'Rapid7 대시보드 템플릿',
      myDashboards: '내 대시보드',
      templateDescription: {
        assets:
          '자산 대시보드는 자산, 자산의 속성과 취약점에 대한 가시성을 제공하므로 사용자 환경에서 가장 중요한 자산과 이러한 자산에 대한 위험 노출을 신속하게 검색하고 파악할 수 있습니다.',
        changed:
          '변경 사항 대시보드를 이용하면 변경 사항, 새로 검색된 자산 및 기준 메트릭을 효율적으로 파악하여 컨텍스트를 설정할 수 있습니다.',
        executive:
          '위험 노출이 완화 또는 악화 중인지 파악합니다. 투자 수익을 실현하기 위해 팀의 성과 및 핵심 지표를 파악합니다.',
        exploitableVulns:
          '익스플로이트가 가능한 취약점 대시보드는 알려진 익스플로이트 키트 또는 멀웨어와 관련한 취약점 데이터에 대한 가시성을 제공합니다.',
        petya:
          '이 대시보드에는 Petya와 유사한 랜섬웨어가 발생했는지를 즉각적으로 확인할 수 있게 해주는 한 세트의 카드가 포함되어 있고 이러한 유형의 랜섬웨어는 취약점(MS17-010)을 익스플로이트하여 전파되기도 합니다.',
        remediations:
          '문제 해결 대시보드를 사용하면 문제 해결 활동을 확인할 수 있어 다음 문제에 집중할 수 있음: 위험 프로젝트, 지원이 필요한 문제 해결 팀 또는 최상의 문제 해결 팀에 집중할 수 있습니다.',
        samba:
          '이 대시보드에는 프로필이 높은 다음 취약점을 즉시 확인할 수 있는 카트 세트가 포함됨: Samba(CVE-2017-7494). 이 카드에는 이 취약점과 관련이 있는 귀사의 보안 포스처를 보고하기 위한 사용자 정의 필터가 적용되었습니다.',
        threatFeed:
          '위협 피드 대시보드는 익스플로이트가 가능하고 Rapid7 위협 피드를 통해 적극적으로 추적 및 익스플로이트되는 취약점 데이터에 대한 가시성을 제공합니다.',
        vulnerabilities:
          '취약점 대시보드는 취약점의 존재 및 성격에 대한 가시성을 제공하므로 사용자 환경에서 다음에 취할 가장 중요한 조치를 파악할 수 있습니다.',
        wannaCry:
          '이 대시보드에는 WannaCry 랜섬웨어가 발생했는지를 즉각적으로 확인할 수 있게 해주는 한 세트의 카드가 포함되어 있고, 이러한 유형의 웜은 취약점(CVE-2017-0144)을 익스플로이트하여 전파됩니다. 이 카드에는 WannaCry와 관련이 있는 귀사의 보안 포스처를 보고하기 위한 사용자 정의 필터가 적용되었습니다.',
      },
      templateName: {
        assets: '자산 대시보드',
        changed: '변경 사항 대시보드',
        executive: '요약 대시보드',
        exploitableVulns: '익스플로이트 가능 취약점 대시보드',
        petya: 'Petya 유사 랜섬웨어',
        remediations: '문제 해결 대시보드',
        samba: 'Samba',
        threatFeed: '위협 피드 대시보드',
        vulnerabilities: '취약점 대시보드',
        wannaCry: 'WannaCry',
      },
    },
    dashboardLibraryLabel: '$t(dashboardLabel) 라이브러리',
    dashboardName: '$t(dashboardLabel) 이름',
    dashboardsFailed:
      '대시보드를 검색하지 못했습니다. 새로 고치고 나중에 다시 시도하십시오.',
    dashboardsSaveFailed: '주의: 대시보드를 저장하지 못했습니다',
    databaseName: '데이터베이스 이름',
    databases: '데이터베이스',
    date: '날짜',
    days: '일',
    defaultDashboard: '기본 대시보드',
    defaultDelete: '기본 대시보드는 삭제할 수 없습니다',
    defaultNameChangeAlert: '기본 대시보드 이름은 변경할 수 없습니다',
    delete: '삭제',
    deleteDashboard: '삭제하시겠습니까?',
    deleteIconToolTip: '카드 삭제',
    description: '설명',
    details: '세부 정보',
    deviceClass: '디바이스 클래스',
    disabled: '비활성화됨',
    discoveredByConnection: '연결로 검색됨',
    discoveryDate: '발견 날짜',
    dismiss: '무시',
    downloadAgent: '에이전트 다운로드',
    downloadAgents: '에이전트 다운로드',
    downloading: '다운로드 중',
    dueOn: '기한 날짜',
    duplicate: '중복',
    duplicateDashboard: '$t(duplicate) $t(dashboardLabel)',
    duplicateWidgetTitle: '중복 카드',
    dynamic: '동적',
    edit: '편집',
    edited: '카드 확대',
    ellipses: '__phrase__...',
    enableLiveMonitoring: '실시간 모니터링 활성화',
    enabled: '활성화됨',
    error: '오류',
    exceptionScope: '예외 처리 범위',
    exceptions: '예외 처리',
    expandCard: '카드 확대',
    expirationTime: '만료일',
    expiresOn: '만료일',
    expiringOn: '만료일',
    exploit: '익스플로이트',
    exploitCount: '익스플로이트 횟수',
    exploitDB: '$t(exploit) DB',
    exploitRank: '등급',
    exploitRanks: {
      average: '평균값',
      excellent: '매우 우수',
      good: '양호',
      great: '우수',
      low: '낮음',
      manual: '수동',
      normal: '보통',
    },
    exploitableVulnerabilities: '익스플로이트 가능 취약점',
    exploitableVulns: '$t(exploitableVulnerabilities)',
    exploits: '익스플로이트',
    exportToCSV: 'CSV로 내보내기',
    exposure: '노출',
    exposureValues: {
      common: '일반적',
      favored: '자주',
      occasional: '가끔',
      popular: '매우 자주',
      rare: '매우 드문',
      uncommon: '드문',
      undefined: '정의되지 않음',
      unknown: '알 수 없음',
    },
    failed: '실패',
    false: '거짓',
    family: '제품군',
    fileName: '파일 이름',
    files: '파일',
    filesAndDirectories: '파일 및 디렉토리',
    filter: {
      asset: {
        addressType: '주소 유형',
        assetId: '자산 ID',
        assetKey: '자산의 고유한 식별자',
        assetType: '자산 유형',
        exploitCount: '익스플로이트 횟수',
        hostName: '$t(hostName)',
        ipAddress: 'IP 주소',
        mac: 'MAC 주소',
        malwareCount: '멀웨어 수',
        operatingSystem: '운영 체제',
        riskScore: '위험 지수',
        vulnerabilityCount: '취약점 수',
      },
      'asset-group': {
        assets: '자산',
        groupId: '그룹 ID',
        groupName: '그룹 이름',
        isDynamic: '은(는) 동적 자산임',
        riskScore: '위험 지수',
        vulnerabilities: '취약점',
      },
      cardError: {
        actionableCardError:
          '카드 로드 도중 오류가 발생했습니다. 카드를 <a class="action reload-card">다시 로드</a>하거나 <a class="action delete-card">삭제</a>하십시오.',
        actionableFilterError:
          '연결된 필터에서 오류가 발생하여 카드를 로드할 수 없습니다. 기본값으로 <a class="action reset-card">재설정</a>하거나 이 카드를 <a class="action delete-card">삭제</a>하십시오',
        cardError:
          '카드 로드 도중 오류가 발생했습니다. 카드를 다시 로드하거나 대시보드 소유자에게 문의하여 카드를 재설정하거나 삭제하십시오.',
        filterError:
          '관련 필터에서 오류가 발생하여 카드를 로드할 수 없습니다. 필터를 재설정하거나 제거하려면 대시보드 소유자에게 문의하십시오.',
      },
      filterName: '$t(filterLabel) 이름',
      filterText: '$t(filterLabel) 텍스트',
      management: {
        allFilter: '전체 $t(filters)',
        createError: '$t(filterLabel) "__filterName__” 생성 도중 오류 발생',
        createFilter: '$t(filterLabel) 생성',
        createSuccess: '$t(filterLabel) "__filterName__"이(가) 생성됨',
        deleteConfirmation:
          '필터를 삭제하면 연결된 모든 카드 또는 프로젝트에서 삭제됩니다. 삭제하시겠습니까?',
        deleteError:
          '선택한 필터 삭제 중 오류가 발생했습니다. 나중에 다시 시도하십시오.',
        deleteError_plural:
          '선택한 필터 삭제 중 오류가 발생했습니다. 나중에 다시 시도하십시오.',
        deleteSavedFilter: '저장된 필터 삭제',
        deleteSharedOnly: '모두 공유되어 삭제된 필터가 없습니다.',
        deleteSuccess:
          '$t(filterLabel)이(가) 삭제되어 사용된 카드에서 삭제됩니다.',
        deleteSuccess_plural:
          '__count__ $t(filters)개가 삭제되어 사용된 카드에서 삭제됩니다.',
        duplicateFilter: '$t(filterLabel) 복제',
        editFilter: '$t(filterLabel) 편집',
        saveError:
          '"__filterName__" 필터 업데이트 도중 오류가 발생했습니다. 나중에 다시 시도하십시오.',
        saveSuccess:
          '$t(filterLabel) "__filterName__"이(가) 업데이트되었습니다.',
      },
      notFound: {
        actionableDescription:
          '이 카드에 적용된 필터가 소유자에 의해 삭제되었습니다. 기본값으로 <a class="action reset-card">재설정</a>하거나 이 카드를 <a class="action delete-card">삭제</a>하십시오.',
        description:
          '이 카드에 적용된 필터가 소유자에 의해 삭제되었습니다. 필터를 업데이트하거나 제거하려면 대시보드 소유자에게 문의하십시오.',
      },
      os: {
        'attribute.deviceType': '디바이스 유형',
        'attribute.operatingSystemDescription': '운영 체제 설명',
        'attribute.product': '제품',
        'attribute.productFamily': '제품군',
        'attribute.productVendor': '제품 공급업체',
        'attribute.systemArchitecture': '시스템 아키텍처',
        'attribute.version': '버전',
        count: '수',
      },
      site: {
        assetCount: '자산 수',
        autoEngineSelectionEnabled: '엔진 선택 활성화됨',
        criticalVulnerabilityCount: '심각도 상 취약점 수',
        dynamic: '동적',
        key: '키',
        moderateVulnerabilityCount: '심각도 하 취약점 수',
        name: '이름',
        riskFactor: '위험 요소',
        riskScore: '위험 지수',
        riskScoreTimestamp: '위험 지수 타임스탬프',
        severeVulnerabilityCount: '심각도 상 취약점 수',
        siteID: '사이트 ID',
      },
    },
    filterLabel: '필터',
    filters: '필터',
    find: '검색',
    fingerprints: '핑거프린트',
    firstFound: '검색됨',
    fix: '수정',
    groups: '그룹',
    hardware: '하드웨어',
    hostName: '호스트 이름',
    hostNames: '호스트 이름',
    hostType: '호스트 유형',
    id: 'ID',
    installedSoftware: '설치된 소프트웨어',
    instanceCount: '인스턴스',
    instances: '인스턴스',
    ipAddress: 'IP 주소',
    ipAddresses: 'IP 주소',
    kpi: 'KPI',
    labels: {
      assetGroups: '자산 그룹',
    },
    lastOnline: '마지막 온라인',
    lastScan: '마지막 스캔',
    learnMore: '자세한 내용',
    list: {
      loading: '테이블 데이터를 로드 중입니다.',
    },
    liveAssessmentDescription:
      '에이전트는 실시간 평가 및 모니터링<br>프로그램의 의 핵심 구성 요소입니다. 자산은 원격 자산에서 정보를 수집하여, 사용자가 스캔을 추가할 필요 없이 더 많은 자산을 추적할 수 있도록<br>해줍니다.',
    loadingIssueTypes: '문제 유형 로드 중',
    location: '위치',
    macAddress: 'MAC 주소',
    macAddresses: 'MAC 주소',
    malware: '멀웨어',
    malwareCount: '멀웨어 수',
    malwareKit: '멀웨어 키트',
    malwareKits: '멀웨어 키트',
    manage: '관리',
    me: 'Me',
    metasploit: 'Metasploit',
    minutes: '분',
    moderate: '하',
    modifiedDate: '수정일',
    modifiedOn: '수정일',
    name: '이름',
    nameIsRequired: '이름을 비워 둘 수 없음',
    newInstances: '새 인스턴스',
    next: '다음',
    next6months: '다음 6개월 내',
    next7days: '다음 7일 내',
    next30days: '다음 30일 내',
    next60days: '다음 60일 내',
    next90days: '다음 90일 내',
    nextScan: '다음 스캔',
    nextYear: '내년에',
    no: '아니요',
    noActiveExploitsAvailable:
      '잦은 공격 대상이 되는 취약점이어서 현재 이 취약점은 Rapid7에서 추적되지 않습니다.',
    noOfAssets: '자산 개수',
    noOfAssetsAffected: '영향을 받은 자산 수',
    noOfInstances: '인스턴스 수',
    noRecords: '검색된 기록이 없습니다.',
    noWidgets: '선택된 카드가 없습니다.',
    numberOfNumber: '__dividend__ / __divisor__',
    offline: '오프라인',
    online: '온라인',
    onlineSince: '온라인 시작 시간',
    open: '개방',
    operatingSystem: '운영 체제',
    operatingSystems: '운영 체제',
    optional: '옵션 사항',
    originalRiskScore: '최초의 위험 지수',
    os: {
      products: '__vendor__ 제품',
      versions: '__vendor__ __product__ 버전',
    },
    osLabel: '운영 체제',
    other: '기타',
    overview: '개요',
    owner: '소유자',
    password: '암호',
    past2weeks: '지난 2주',
    past6months: '지난 6개월',
    past7days: '지난 7일',
    past30days: '지난 30일',
    past60days: '지난 60일',
    past90days: '지난 90일',
    pastDue: '기한 초과',
    pastMonth: '지난달',
    pastWeek: '지난주',
    pastYear: '지난해',
    percent: '__percent__$t(percentageSymbol)',
    percentLabel: '비율',
    percentOfAssets: '자산의 $t(percentageSymbol)',
    percentageSymbol: '%',
    petya: 'Petya',
    policies: '정책',
    policyElement: '정책 요소',
    policyName: '정책 이름',
    policyTitle: '정책 제목',
    port: '포트',
    previous: '이전',
    product: '제품',
    program: '프로그램',
    projects: '프로젝트',
    proof: '증거',
    protocol: '프로토콜',
    publishDate: '게시일',
    publishedOn: '게시일',
    queryBuilder: {
      alternateIds: {
        altId: '대체 id의 id',
        size: '대체 id 수',
        source: '대체 id 소스',
        title: '취약점의 대체 id 모음',
      },
      asset: {
        agentKey: '에이전트 키',
        altips: {
          name: '대체 ips 모음',
          size: '대체 ip 수',
        },
        altmacs: {
          name: '대체 mac 모음',
          size: '대체 mac 수',
        },
        altnames: {
          name: '대체 이름 모음',
          size: '대체 이름 수',
        },
        assetKey: '자산 키',
        averageScanDuration: '평균 스캔 시간',
        console: '기본 콘솔',
        credentialSuccessStatus: '성공 또는 실패 상태 표시',
        endpoints: {
          certainty: 'fp의 엔드포인트 확실성',
          name: '엔드포인트 서비스 이름',
          port: '엔드포인트 포트',
          protocol: '엔드포인트 포트',
          size: '엔드포인트 수',
          title: '엔드포인트 모음',
        },
        firstScanTime: '첫 번째 자산 스캔 날짜',
        groups: '그룹 이름 모음',
        ipv4: '자산의 기본 ipv4',
        ipv6: '자산의 기본 ipv6',
        lastAgentConnectionTime:
          '에이전트에 의한 마지막 연결의 날짜와 시간입니다.',
        lastScanDuration: '가장 최근의 스캔 지속 시간',
        lastScanTime: '가장 최근의 자산 스캔 날짜',
        mac: '자산의 기본 mac',
        name: '자산의 호스트 이름',
        os: {
          arch: '자산 운영 체제 아키텍처',
          description: '자산 운영 체제 설명',
          family: '자산 운영 체제 집합',
          product: '자산 운영 체제 제품',
          title: '기본 자산 운영 체제 개체',
          type: '자산 운영 체제 유형',
          vendor: '자산 운영 체제 공급업체',
          version: '자산 운영 체제 버전',
        },
        riskScore: '자산 위험 지수',
        sites: '사이트 이름 모음',
        software: {
          description: '소프트웨어 설명',
          family: '소프트웨어 제품군',
          product: '소프트웨어 제품',
          program: '소프트웨어 프로그램',
          size: '설치된 소프트웨어 수',
          title: '소프트웨어 개체 모음',
          vendor: '소프트웨어 공급업체',
          version: '소프트웨어 버전',
        },
        sslCertificateMinimumExpirationDate: 'ssl 인증서 만료',
        tags: {
          name: '태그 이름',
          type: '태그 유형',
        },
        type: '자산의 호스트 유형',
      },
      assetgroup: {
        assets: {
          description: '그룹 내 자산',
          size: '그룹 내 자산 수',
        },
        dynamic: '정적 또는 동적 표시',
        groupKey: '그룹의 고유한 ID',
        name: '자산 그룹의 이름',
        riskScore: '그룹의 위험 지수',
        vulnCount: '취약점 수',
      },
      exploits: {
        description: '익스플로이트 설명',
        exploitRank: '익스플로이트 등급',
        id: '익스플로이트 id',
        name: '익스플로이트 이름',
        rank: '익스플로이트 등급',
        size: '취약점 익스플로이트 수',
        source: '익스플로이트 소스',
        title: '취약점이 속해 있는 익스플로이트 모음',
      },
      help: {
        title: '구문 도움말 / 쿼리 사전',
      },
      nameIsRequired: '$t(nameIsRequired)',
      placeholder: '클릭하여 새 필터 생성',
      saveFilter: {
        placeholder: '필터 저장',
        title: '필터 저장',
      },
      selectSavedQuery: '저장된 쿼리 선택',
      site: {
        assets: {
          description: '사이트 내 자산',
          size: '사이트 내 자산 수',
        },
        autoEngineSelected: '자동 엔진 상태 표시',
        dynamic: '정적 또는 동적 표시',
        name: '사이트의 이름',
        riskFactor: '사이트의 위험 요소',
        riskScore: '사이트의 위험 지수',
        siteKey: '사이트의 고유한 식별자',
        status: '사이트 상태',
        vulnCount: '사이트 내 취약점 수',
      },
      solution: {
        fix: '해당 취약점의 해결 방법 수정',
        solutionKey: '해당 취약점의 해결 방법 키',
        summary: '해당 취약점의 해결 방법 요약',
      },
      tag: {
        assets: {
          description: '태그 내 자산',
          size: '태그 내 자산 수',
        },
        groups: {
          description: '태그 내 그룹',
          size: '태그 그룹 수',
        },
        name: '태그 이름',
        riskModifierAttribute: '태그 위험 수정자',
        sites: {
          description: '태그 내 사이트',
          size: '태그 사이트 수',
        },
        sourceAttribute: '태그 소스 속성',
        tagKey: '태그의 고유한 식별자',
        type: '태그 유형',
      },
      type: {
        IP: 'IP 주소',
        boolean: '부울',
        date: '날짜',
        duration: '소요 시간',
        object: '개체',
        objectCollection: '개체 모음',
        standardNumber: '개수',
        standardString: '문자열',
        stringCollection: '문자열 모음',
      },
      vulnerability: {
        assetKey: '자산 키',
        categories: {
          size: '범주 수',
          title: '취약점이 속해 있는 범주',
        },
        cveIds: '취약점의 cve id 목록',
        cvssScore: '취약점 cvss 지수',
        dateModified: '취약점이 마지막으로 수정된 날짜',
        datePublished: '취약점이 게시된 날짜',
        description: '취약점 설명',
        malwareKits: {
          size: '멀웨어 키트 수',
          title: '취약점과 관련된 멀웨어 키트',
        },
        object: '취약점에 대한 사실 캡슐화',
        pciCompliant: '자산의 PCI 준수 여부 표시',
        port: '취약점 엔드포인트 포트',
        protocol: '취약점 엔드포인트 프로토콜',
        risk: '취약점 위험(다시 스캔하지 않을 경우 오래된 내용일 수 있음)',
        severity: '취약성 심각도',
        severityScore: '취약점 심각도 지수 수치',
        size: '취약성의 개수',
        skillLevel: '취약점 기술 수준',
        software: '소프트웨어의 복합 문자열 id',
        softwareFamily: '취약점의 소프트웨어 제품군',
        softwareProduct: '취약점의 소프트웨어 제품',
        softwareVendor: '취약점의 소프트웨어 공급업체',
        softwareVersion: '취약점의 소프트웨어 버전',
        title: '취약점 이름',
        vulnKey: '취약점의 고유한 식별자',
      },
      vulnerabilityexception: {
        asset: {
          ipv4: '예외가 적용된 자산의 ipv4',
          ipv6: '예외가 적용된 자산의 ipv6',
          key: '예외가 정의된 자산의 키',
          name: '예외가 적용된 자산의 이름',
          size: '태그 내 자산 수',
        },
        expirationTime: '예외 만료 시간',
        port: '예외가 정의된 포트',
        reason: '예외 처리 이유',
        reasonDetails: '예외 처리 이유의 세부 정보',
        reviewerActionTime: '검토자의 작업 시간',
        reviewerKey: '검토자의 키',
        reviewerReason: '검토자 작업의 이유',
        scope: '예외 처리의 범위',
        siteKey: '예외가 정의된 사이트의 키',
        state: '예외 처리 상태',
        submitterActionTime: '제출자의 작업 시간',
        submitterKey: '제출자의 키',
        vulnExceptionKey: '취약점 예외 처리의 고유한 식별자',
      },
    },
    ra: {
      affectedAssets: '영향을 받은 자산',
      assignees: '할당 대상',
      description:
        '사용자가 네트워크에서 수행할 수 있고 전체 위험 지수 감소에 가장 도움이 될 문제 해결 방법이 강조 표시된 카드입니다.',
      project: {
        access: '액세스',
        accessDescription:
          '이 프로젝트와 연결된 자산에 액세스할 수 없는 사용자가 볼 수 있도록 허용',
        assetCountExceeded:
          '프로젝트당 __maxAssets__ 자산의 한계가 있습니다. 쿼리를 미세 조정하십시오.',
        assetFilter: '자산 필터',
        assetSelectionExceeded:
          '프로젝트당 __maxAssets__ 자산의 한계가 있습니다. 일부 자산의 선택을 취소한 후 다시 시도하십시오.',
        cardAssetFilter: '카드 자산 필터',
        cardVulnerabilityFilter: '카드 취약점 필터',
        chooseConnection: '프로젝트 연결 선택',
        createProject: '문제 해결 프로젝트 만들기',
        deleteError: '문제 해결 프로젝트 삭제 도중 오류가 발생했습니다.',
        deleteProjectConfirm: '선택한 프로젝트를 삭제하시겠습니까?',
        deleteProjectTitle: '프로젝트 삭제 확인',
        editProject: '문제 해결 프로젝트 편집',
        entity: {
          assignees: '할당 대상',
          completedAssetsPercent: '% 자산 완료',
          completedRemediations: '해결 방법 해결됨',
          completedRemediationsPercent: '진행',
          createdOn: '$t(createdOn)',
          description: '설명',
          dueOnTime: '기한 날짜',
          numAssets: '영향을 받은 자산',
          ownerName: '소유자',
          progress: '진행',
          remainingRemediations: '문제 해결 남음',
          remainingTime: '남은 시간',
          remainingWork: '작업 남음',
          serverActive: '티켓 발행',
          status: '상태',
          title: '프로젝트 이름',
          totalRemediations: '총 문제 해결',
          totalRisk: '누적 위험',
          type: '유형',
        },
        filterPlaceholder: '클릭하여 필터 추가',
        minimumDate: '기한은 오늘이거나 이후여야 합니다.',
        nameInUse: '이 이름은 이미 사용 중입니다',
        nameIsRequired: '$t(nameIsRequired)',
        overview: {
          title: '프로젝트 개요',
        },
        owner: {
          active: '$t(active)',
          email: '이메일',
          userFullName: '이름',
          userKey: '사용자 ID',
          userName: '사용자 이름',
        },
        ownerTitle: '프로젝트 소유자',
        populatingNoRows:
          '검색된 기록이 없습니다. 프로젝트가 최근 생성된 경우 해결 방법과 함께 모든 정보를 자동으로 채우려면 몇 분이 걸릴 수 있습니다.',
        populatingWarning:
          '프로젝트가 생성되었습니다. 해결 방법과 함께 모든 정보를 자동으로 채우려면 몇 분이 걸릴 수 있습니다.',
        projectContent: '프로젝트 내용',
        status: {
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
        },
        ticketingConfigurationWarning:
          '여기에서 선택한 사항은 나중에 변경할 수 없습니다.',
        type: {
          DYNAMIC: '동적',
          STATIC: '정적',
        },
        updateError: '$t(cards.assets.drilldown.remediation.errorNotification)',
        updateStatusError:
          '문제 해결 프로젝트 업데이트 도중 오류가 발생했습니다.',
        updateToClosedStatus: '선택한 프로젝트 종료',
        updateToOpenStatus: '선택한 프로젝트 열기',
        viewProject: '프로젝트 보기',
        vulnerabilityFilter: '취약점 필터',
      },
      projectError: {
        entity: {
          description: '설명',
          errorType: '오류 코드',
          timeOccurred: '오류 날짜',
        },
        errorsDescription:
          '문제 해결 프로젝트의 티켓 발행에서 오류가 발생했습니다. 자세한 오류 내용을 아래에서 확인하십시오',
        errorsHeader:
          '문제 해결 워크플로 __projectName__에서 티켓 발행 오류가 발생했습니다',
        message: {
          BAD_STATE:
            '잘못된 상태- __SERVER_NAME__ 서버에 문제 해결 상태 __REMEDIATION_STATUS__에 대한 매핑이 없습니다',
          FAIL_COMMENT_1:
            '__ISSUE_KEY__ 발행을 위한 설명 추가 실패- 중단되거나 시간 초과.',
          FAIL_COMMENT_2:
            '__ISSUE_KEY__ 발행을 위한 설명 추가 실패- 오류 실행.',
          FAIL_ISSUE_1: '__ISSUE_KEY__ 발행 실패- 중단되거나 시간 초과.',
          FAIL_ISSUE_2: '__ISSUE_KEY__ 발행 실패 - 오류 실행.',
          FAIL_STATUS_1:
            '__ISSUE_KEY__ 발행 실패- 중단되거나 시간 초과. 이로 인해 문제 해결을 위한 상태 동기화를 할 수 없음: __REMEDIATION_SOLUTION_NAME__.',
          FAIL_STATUS_2:
            '__ISSUE_KEY__ 발행 실패 - 오류 실행. 이로 인해 문제 해결을 위한 상태 동기화를 할 수 없음: __REMEDIATION_SOLUTION_NAME__.',
          FAIL_TICKET_1:
            '다음에 대한 티켓 서버 세부 내용을 획득할 수 없음: URL 주소가 다음과 같은 __SERVER_NAME__: __URL__. 자산 __USER_REMEDIATION_ASSET_NAMES__에서 사용자 __USER_NAME__에 대한 문제 해결__REMEDIATION_UUID__ 티켓을 만들 수 없습니다.',
          FAIL_TICKET_2:
            '__type__ 문제 생성 실패 - 중단되거나 시간 초과. 자산 __USER_REMEDIATION_ASSET_NAMES__에서 사용자 __USER_NAME__에 대한 문제 해결__REMEDIATION_UUID__ 티켓을 만들 수 없습니다.',
          FAIL_TICKET_3:
            '__type__ 문제 생성 실패 - 실행 오류. 자산 __USER_REMEDIATION_ASSET_NAMES__에서 사용자 __USER_NAME__에 대한 문제 해결__REMEDIATION_UUID__ 티켓을 만들 수 없습니다. __type__의 오류 모음 반환: __ERROR_COLLECTION__.',
          FAIL_TICKET_4:
            '지정된 필드 매핑으로 티켓을 생성하는 도중 오류가 발생했습니다. 자산 __USER_REMEDIATION_ASSET_NAMES__에서 사용자 __USER_NAME__에 대한 문제 해결__REMEDIATION_UUID__ 티켓을 만들 수 없습니다.',
          MAX_TICKETS:
            '이 프로젝트에 __MAX_TICKET_NUMBER__개의 티켓이 있습니다. 추가로 티켓을 생성할 수 없습니다. 추가로 티켓을 생성하려면 별도의 프로젝트를 만드십시오.',
          SERVER_DETAILS: '티켓 서버 세부 내용을 검색할 수 없습니다.',
          STATUS_DETAILS:
            '이 서버에 대한 상태 매핑이 없습니다. 문제 해결 상태를 업데이트할 수 없습니다.',
          USER_DETAILS: '이 프로젝트에 대한 할당 규칙이 없습니다.',
        },
      },
      projects: {
        createProject: '프로젝트 만들기',
        editProject: '문제 해결 프로젝트 편집',
        metrics: {
          numAssignedMeProjects: '나에게 할당됨',
          numClosedProjects: '$t(closed)',
          numOpenProjects: '$t(open)',
          numOwnedMeProjects: '내 소유',
          numProjects: '__numProjects__ 프로젝트',
        },
        title: '문제 해결 프로젝트',
      },
      remediation: {
        entity: {
          assigneeName: '할당자',
          numAssets: '영향을 받은 자산',
          riskReduction: '위험 감소',
          status: '상태',
          summary: '솔루션',
          unresolvedVulns: '$t(vulnerabilities)',
        },
        metrics: {
          assigned: '할당됨',
          assignedToMe: '나에게 할당됨',
          numRemediations: '__numRemediations__ 해결 방법',
          pendingVerification: '확인 보류 중',
          unassigned: '할당되지 않음',
          unknownSolutions: '알 수 없는 해결 방법',
        },
        status: {
          AWAITING_VERIFICATION: '확인 대기 중',
          CLOSED: '$t(closed)',
          OPEN: '$t(open)',
          OPEN_PENDING: '열기 - 보류 중',
          REOPEN: '다시 열기',
          WILL_NOT_FIX: '수정되지 않음',
          WILL_NOT_FIX_PENDING: '수정되지 않음 - 보류 중',
        },
        tableTitle: '문제 해결 방법',
        updateError: '문제 해결 방법 업데이트 도중 오류가 발생했습니다.',
        updateStatus: '상태 업데이트',
      },
      riskScoreImageTitle: '자산의 위험 지수 증가 또는 감소.',
      solution: {
        entity: {
          additionalInfo: '추가 정보',
          fix: '수정',
          solutionId: '해결 방법 ID',
          summary: '요약',
          url: 'URL',
        },
      },
      solutionTitle: '해결 방법',
      solutions: '솔루션',
      summaryInformation: '요약 정보',
      ticketing: {
        addConnection: '티켓 발행 연결 추가',
        addRuleInfo: '새 규칙을 클릭하여 규칙 추가',
        addStatus: '+ 상태 추가',
        assignmentRule: '할당 규칙',
        assignmentRuleDescription:
          '문제 해결 세부 내용의 정보를 기준으로 티켓이 할당될 사용자에 대한 규칙을 만드십시오. 규칙을 여러 개 만들 수 있고 적용 순서를 설정할 수 있습니다.',
        assignmentRules: '할당 규칙',
        assignmentRulesDescription:
          '할당 규칙을 사용하면 __type__ 사용자에게 티켓을 자동으로 할당할 수 있습니다. 아래에서 새 규칙을 추가하고 다시 할당하여 규칙 세트의 우선순위를 지정하십시오. 규칙은 위에서 아래로의 순서로 적용됩니다.',
        assignmentRulesHeader:
          '__type__ 프로젝트 __name__에 대한 새 할당 규칙 만들기',
        automatedTicketing: '자동화 티켓 발행',
        automatedTickets: '자동화 티켓',
        automatedTicketsNotConfigured: '자동화 티켓 발행이 구성되지 않음',
        changeConnection: '연결 변경',
        chooseConnection: '프로젝트 연결 선택',
        closeWizardWarning:
          '취소하시겠습니까? 매핑과 템플릿은 저장되지 않습니다. 티켓 발행 연결만 유지됩니다.',
        configurations: '구성',
        configurationsDescription:
          '티켓 발행 템플릿 이름을 클릭하여 기존 구성을 편집하십시오. 새 구성 버튼을 클릭하여 새 구성을 추가하십시오.',
        configure: '구성',
        configured: '__fieldMappingName__용으로 구성됨',
        configuredWarning:
          '__type__ 프로젝트 연결을 변경할 수 없습니다. 다른 티켓 발행 구성을 사용하려면 새 프로젝트를 만드십시오.',
        connectionSettings: '연결 설정',
        createServerWarning: '연결을 구성한 후에 계속 진행하십시오',
        defaultAssignee: '기본 할당자',
        deleteConnection: '연결 삭제',
        deleteConnectionDisabled:
          '활성 티켓 발행 연결이 있는 문제 해결 프로젝트가 있습니다. 티켓 발행 서버 연결을 삭제하려면 이 프로젝트를 삭제해야 합니다.',
        deleteServerWarning: '이 서버를 삭제하시겠습니까?',
        disabled: '구성됨, 비활성화됨',
        enabled: '구성됨, 활성화됨',
        error: '구성됨, 오류',
        errorsDescription:
          '문제 해결의  프로젝트 티켓 발행에서 오류가 발생했습니다. 자세한 오류 내용을 아래에서 확인하십시오.',
        errorsHeader:
          '문제 해결 워크플로 __projectName__에서 티켓 발행 오류 발생',
        fieldDescription: '필드 설명',
        fieldMappingDescription:
          '티켓 생성 시 설정될 값을 지정하십시오. 구문 도움말에는 티켓에서 문제 해결 데이터에 사용할 수 있는 변수가 포함되어 있습니다. 제안된 기본값이 제공되었습니다.',
        fieldMappingError:
          '필드 매핑을 저장할 수 없습니다. 나중에 다시 시도하십시오.',
        fieldMappingHeader: '__type__ 프로젝트 __name__용 필드 매핑',
        fieldMappingNoValuesExist: '이 값은 필수이지만 옵션이 없습니다.',
        fieldMappingRequired:
          '* 각 문제 해결 방법 상태에 대하여 최소 1개의 티켓 발행 시스템 상태를 선택해야 합니다.',
        fieldMappingSuccess: '필드 매핑이 업데이트되었습니다.',
        inactiveWarning: '편집하려면 서버가 활성화되어야 합니다.',
        integration: '문제 해결 티켓 통합',
        issueKey: '발행 키',
        issueType: '발행 유형',
        manageConnections: '티켓 발행 연결 관리',
        newRule: '새 규칙',
        noIssueTypeForProjectKey:
          '다른 프로젝트 키를 선택하십시오. 이 키에는 발행 유형이 없습니다',
        notConfigured: '구성되지 않음',
        projectAndFieldMapping: '티켓 발행 프로젝트 및 필드 매핑',
        projectError:
          '__projectName__ 프로젝트에 __count__개의 티켓 발행 오류가 있습니다.',
        projectErrorTitle:
          '문제 해결 워크플로 __projectName__에서 __count__개의 티켓 발행 오류가 발생했습니다.',
        projectKey: '프로젝트 키',
        projectKeyDescription: '선택한 프로젝트에서 발행이 생성됩니다',
        projectName: '프로젝트 이름',
        remediationStatusButtonWarning:
          '이 버튼은 선택한 문제 해결의 상태가 모두 동일한 경우에만 활성화됩니다(열기/다시 열기/확인 대기 중 상태).',
        replacementString: {
          $ASSET_IP_LIST: '쉼표로 구분되는 자산 ips 목록입니다.',
          $ASSET_NAME_LIST: '쉼표로 구분되는 자산 이름 목록입니다.',
          $ASSET_OS_LIST: '쉼표로 구분되는 자산 운영 체제 목록입니다.',
          $DUE_ON: '문제 해결 프로젝트의 기한입니다.',
          $PROJ_NAME: '프로젝트 이름입니다.',
          $PROJ_UUID: '프로젝트 uuid입니다.',
          $SOL_ADDL_INFO: '해결 방법 추가 정보입니다.',
          $SOL_FIX: '해결 방법 수정 단계',
          $SOL_NAME: '해결 방법 이름입니다.',
          $SOL_URL: '해결 방법 참조 URL',
          $VULN_ID_LIST: '쉼표로 구분되는 취약점 ID 목록입니다.',
        },
        ruleSetName: '규칙 세트 이름',
        schemaSettingsDescription:
          ' 티켓 발행 서버에서 특정 프로젝트로의 연결을 만드십시오. 추가 프로젝트에 연결을 만든 후 유형은 나중에 발행할 수 있습니다.',
        schemaSettingsHeader:
          '티켓 발행 프로젝트를 연결하고 __name__에 유형을 발행하십시오.',
        selectStatus: '상태 선택 *',
        serverConnectionAuthenticationError:
          '티겟 발행 서버에 연결할 수 없습니다. 입력한 사용자 이름 및 암호가 올바른지 확인하십시오.',
        serverConnectionAuthorizationError:
          '티겟 발행 서버에 연결할 수 없습니다. 입력한 계정이 <a href="https://help.rapid7.com/insightvm/en-us/#Files/Ticketing_integration.html" target="_blank" rel="noopener noreferrer">요구 사항</a>을 충족하는지 확인하십시오.',
        serverConnectionDeleteError:
          '연결을 삭제할 수 없습니다. 다시 시도하십시오.',
        serverConnectionDeleteSuccess: '연결이 삭제되었습니다.',
        serverConnectionError:
          '서버 연결을 생성할 수 없습니다. 다시 시도하십시오.',
        serverConnectionInactiveWarning:
          '서버 연결이 저장되었지만 계속 진행하려면 활성화되어야 합니다.',
        serverConnectionSuccess: '서버 연결이 생성되었습니다.',
        serverCreated: '티켓 발행 서버가 생성되었습니다',
        serverName: '서버 이름',
        serverSettingsDescription:
          '__type__ 등 티켓 발행 프로그램의 인스턴스로의 연결을 생성하십시오.',
        serverSettingsDescription2:
          '이 3단계에서는 1개의 __type__ 프로젝트, 발행 유형 및 규칙 구성에 연결을 추가하는 방법이 설명됩니다.',
        serverSettingsHeader: '__type__ 티켓 발행 서버에 연결',
        serverSettingsUserWarning:
          '이 필드를 사용하려면 사용자가 다음 __type__ 권한을 가져야 함:',
        serverSettingsWarning: '이 작업을 통해 __type__ 서버에 연결됩니다.',
        serverSettingsWarning2:
          '문제 해결 워크플로 프로젝트에 티켓 발행 연결을 연결할 때까지 티켓이 생성되지 않습니다.',
        serviceNowStatusMappingWarning:
          'ServiceNow에서 원하는 상태를 생성한 후 매핑하십시오.',
        servicePickerDescription: '티켓 발행 서비스를 클릭하여 구성',
        servicePickerHeader: '연결을 관리할 티켓 발행 서버 선택',
        solutionStatus: '문제 해결 방법 상태',
        solutionStatusMapping: '해결 방법 상태 매핑',
        statusMappingDescription:
          '티켓 발행 프로그램에서 InsightVM의 각 문제 해결 상태를 프로젝트 상태와 일치시키십시오.',
        statusMappingError:
          '프로젝트 문제 해결 상태 매핑을 저장할 수 없습니다. 나중에 다시 시도하십시오.',
        statusMappingHeader: '__name__에 대한 해결 방법 상태 매핑 설정',
        statusMappingSuccess: '상태 매핑이 업데이트되었습니다.',
        syntaxHelp: '구문 도움말',
        templateName: '티켓 발행 템플릿 이름',
        ticketingConnection: '티켓 발행 연결',
        ticketingSystemStatus: '티켓 발행 시스템 프로젝트 상태',
        ticketsCreated: '티켓 생성됨: __count__',
        type: {
          JIRA: 'JIRA',
          SERVICENOW: 'ServiceNow',
        },
        userMappingDescription:
          '필터 기준에 따라 티켓 할당자를 결정하는 규칙을 만드십시오. 이 규칙은 우선순위 1부터 아래로 적용됩니다. 티켓이 규칙 기준을 충족하지 않으면 기본 할당자로 할당됩니다.',
        userMappingError:
          '사용자 매핑을 저장할 수 없습니다. 나중에 다시 시도하십시오.',
        userMappingHeader: '__type__ 프로젝트 __name__에 대한 할당 규칙',
        userMappingSuccess: '사용자 매핑이 업데이트되었습니다.',
        vulnerabilityFilterRequired:
          '티겟 발행이 포함된 프로젝트에서는 취약점 필터가 필요합니다',
        wizardHeader: '티켓 발행 연결 설정',
      },
      title: '위험 지수에 가장 큰 영향을 주는 문제 해결 방법',
      user: {
        userName: '사용자 이름',
      },
      vulnerabilities: '취약점',
    },
    range: '__from__-__to__ __unit__',
    reason: '원인',
    references: '참조 자료',
    refresh: '새로 고침',
    reload: '다시 로드',
    remainingInstances: '나머지 인스턴스',
    remediated: '해결됨',
    remediatedInstances: '해결된 인스턴스',
    remediatedVuln: '해결된 취약점',
    remediation: '문제 해결',
    remediations: '문제 해결',
    removeWidget: '"__title__" 카드를 삭제하시겠습니까?',
    removeWidgetTitle: '카드 삭제',
    renameDashboard: '$t(dashboardLabel) 이름 변경',
    reportedBy: '보고자',
    required: '필수',
    reset: '재설정',
    result: '결과',
    reviewStatus: '검토 상태',
    risk: '위험',
    riskOverTime: '시간에 따른 위험',
    riskScore: '$t(riskScoreLabel): __riskScore__',
    riskScoreDecrease: '위험 지수 감소',
    riskScoreIncrease: '위험 지수 증가',
    riskScoreLabel: '위험 지수',
    riskScoreReduction: '위험 지수 감소',
    riskTrend: '위험 추세',
    ruleCompliance: '규칙 준수',
    samba: 'Samba CVE-2017-7494',
    sambaWithCve: '$t(samba) 포함',
    save: '저장',
    saveFilter: '필터 저장',
    scan: '스캔',
    scanDuration: '스캔 시간',
    scanEngine: '스캔 엔진',
    scanHistory: '스캔 이력',
    scanStatus: '스캔 상태',
    score: '지수',
    search: '검색',
    seeDetails: '자세한 내용 보기',
    selectAll: '모두 선택',
    selectAnOption: '옵션 선택',
    selectNone: '모두 선택 취소',
    selectedCount: '__selected__ 선택됨',
    selectedTableText: '(__total__ 중 __selected__ 선택됨)',
    selectionIsEmptyValidation: '선택하십시오',
    serviceName: '서비스 이름',
    services: '서비스',
    severe: '중',
    severity: '심각도: __severity__',
    severityLabel: '심각도',
    shareDashboardWith: '액세스 부여 대상',
    shared: '공유',
    sharedWith: '(__count__ $t(user))와(과) 공유됨',
    sharedWith_plural: '(__count__ $t(user))와(과) 공유됨',
    site: '사이트',
    siteName: '사이트 이름',
    siteTable: {
      inProgress: '스캔 진행 중',
      notScanned: '스캔되지 않음',
      scanFinishedOn: '스캔이 완료됨',
      scanPausedOn: '스캔이 일시 중지됨',
      scheduledScanFinishedOn: '예약된 스캔이 완료됨',
      scheduledScanInProgress: '예약된 스캔 진행 중',
      scheduledScanPausedOn: '예약된 스캔이 일시 중지됨',
    },
    sites: '사이트',
    size: '크기',
    software: '소프트웨어',
    solution: '해결 방법',
    solutions: '해결 방법',
    source: '소스',
    sourceLink: '소스 링크',
    sourceName: '소스 이름',
    sourceType: '소스 유형',
    standardPolicies: '표준 정책',
    static: '정적',
    status: '상태',
    stockchart: {
      buttons: {
        all: '모두',
        monthText: '__text__m',
        weekText: '__text__w',
        yearText: '__text__y',
        ytd: 'YTD',
      },
    },
    success: '성공',
    successful: '성공',
    summary: '요약',
    table: {
      errorMessage: '검색하지 못했습니다. 나중에 시도하십시오.',
      initialError:
        '테이블 로드 도중 오류가 발생했습니다. 나중에 다시 시도하고 <a class="action refresh">다시 로드</a>하십시오.',
      loading: '테이블 데이터를 로드 중입니다.',
    },
    tag: '태그',
    taggedAssets: '태그가 지정된 자산',
    tags: '태그',
    temporalUnit: {
      hours: '시간',
      minutes: '분',
      seconds: '초',
    },
    threatFeed: '위협 피드',
    time: '시간',
    timeSinceLastAssessment: '마지막 평가 이후 시간',
    timeUnits: {
      days: '__count__일',
      days_plural: '__count__일',
      hours: '__count__시간',
      hours_plural: '__count__시간',
      longerThan: "> $t(timeUnits.__timeUnit__, {'count': __time__})",
      minutes: '__count__분',
      minutes_plural: '__count__분',
      months: '__count__개월',
      months_plural: '__count__개월',
      weeks: '__count__주',
      weeks_plural: '__count__주',
      years: '__count__년',
      years_plural: '__count__년',
    },
    title: '제목',
    totalInstances: '총 인스턴스',
    totalRiskScore: '총 위험 지수',
    totalRiskScoreReduction: '총 위험 지수 감소',
    totalVulns: '전체 취약점',
    trends: '동향',
    true: '참',
    type: '유형',
    unchanged: '변경되지 않음',
    unknown: '알 수 없음',
    unknownOS: '$t(unknown) OS',
    unknownOSVendor: '$t(unknown) 운영 체제 벤더',
    updateMessage: '변경 내용이 저장됨',
    url: 'URL',
    user: '사용자',
    username: '사용자 이름',
    users: '사용자',
    usersAndGroups: '사용자 및 그룹',
    vendor: '공급업체',
    vendors: '공급업체',
    version: '버전',
    vuln: '취약점',
    vulnTitle: '취약점 이름',
    vulnerabilities: '취약점',
    vulnerabilitiesOverTime: '시간에 따른 취약점',
    vulnerability: '취약점',
    vulnerabilityCount: '$t(vulnerabilities): __vulns__',
    vulnerabilityException: '취약점 예외 처리',
    vulnerabilityExceptions: '취약점 예외 처리',
    vulnerabilityInstanceStatus: {
      EXCEPTION_VULN_EXPL: '익스플로이트할 수 있는 취약점에 대한 예외',
      EXCEPTION_VULN_POTL: '잠재적 취약점에 대한 예외',
      EXCEPTION_VULN_VERS: '취약한 버전 예외 처리',
      NOT_VULN_DONT_STORE: '취약하지 않음 저장하지 않음',
      NOT_VULNERABLE: '취약하지 않음',
      OVERRIDDEN_VULN_VERS: '오버라이드된 취약점 버전',
      SKIPPED_DISABLED: '건너 뜀(해제됨)',
      SKIPPED_DOS: '생략한 Dos',
      SKIPPED_VERS: '생략한 버전',
      SUPERSEDED: '대체됨',
      UNEXPECTED_ERR: '예상치 못한 오류',
      UNKNOWN: '알 수 없음',
      VULNERABLE_EXPL: '취약함, 익스플로이트됨',
      VULNERABLE_POTENTIAL: '취약함, 잠재적',
      VULNERABLE_VERS: '취약한 버전',
    },
    vulnerabilityInstances: '취약점 인스턴스',
    vulnerabilityLabel: '취약점',
    vulnerabilityLabels: {
      criticalVulnerability: '상 $t(vulnerabilities)',
      moderateVulnerability: '하 $t(vulnerabilities)',
      severeVulnerability: '중 $t(vulnerabilities)',
      trendLine: '시간 경과에 따른 $t(vulnerability) 심각도에 의한 $t(assets)',
      trendLineDescription:
        '시간 경과에 따른 취약점 추세를 보여주는 카드입니다.',
    },
    vulnerabilityTitle: '취약점 이름',
    vulnexception: '$t(vulnerabilityException)',
    vulns: '취약점',
    vulnsInfo: '취약점 정보',
    wannaCry: 'WannaCry',
    weekOf: '__week__ 주',
    withoutAgents: '에이전트 제외',
    yes: '예',
  },
};
